const AsgFW = (function () {
    let asgHosted;
    let version;
    let pamFwUrl;
    let appEnv;
    let pamEnv;
    let cdnHost;
    let fncHost;
    let solarHost;
    let gatewayHost;
    let pamAsgWebApiHost;
    let BrandDomain;
    let OpenPageFunc;
    let CurrencyCode;
    let pamPlatform;
    const exclusiveGameList = [200, 188, 290, 74, 207, 189, 469, 388, 475, 179,
        10, 111, 359, 32, 278, 371, 58, 225, 303, 292];
    let brandID;
    let notPresentGamesData = [];
    let currency;
    let country;
    let isoCountry = '';
    let countryName;
    let detectedRegulation;
    let gameSrvEnvOverride;
    let asgSrvEnvOverride;
    let lastAction = null;
    let allGames = [];
    let allGamesById = {};
    let allGamesByName = [];
    let measureTimerInterval;
    let keepAliveInterval = 10 * 60 * 1000; // 10 minutes on milliseconds
    const statusBarCacheTtl = 3600 * 1000; // set status bar cache for  1 hour
    const cookiesSessionExpirationTime = 60 * 24; // 1 day in minutes
    let lastRegulation = null;
    let lastCountryCode = null;
    let isShowOnlyWinnersOfThisBrand = false;

    let segmentedBannersWeb;
    let segmentedBannerMobile;
    let segmentedBannerSpecial;
    let segmentedBannerPopups;

    let aspireEngageBanners;
    const asgBannersCacheKey = 'asgBanners';

    const hideNetentFlag = true;

    let fireLimit = 3;
    let ngApi;
    let Language = 'ENG';

    // Define Download server mapping (also change it in Constants.php for backend functions).
    const dsProd = 'NG';
    const dsUat = 'ASG';
    const dsQa = 'NG';

    // Values: C - PAM's mobile web; A - PAM's applications (iOS, Android).
    const MOBILE_PAM_PLATFORMS = ['C', 'A'];

    // Top level domains
    const tlds = [
        '.at',
        '.bet',
        '.ca',
        '.co.uk',
        '.com',
        '.de',
        '.dk',
        '.gr',
        '.ie',
        '.pt',
    ];

    // GGL data
    const gamesList = {
        storage: null,
        get data() {
            if (!this.storage) {
                throw new Error('Before accessing Games data please call AsgFW.setOnGamesListUpdated()');
            }
            return this.storage;
        },
    };

    let brandInitData = {};
    let rbcSettings = null;
    let liveCasinoBetLimits = {};
    let liveCasinoStatePromise = null;

    // region Enums
    const fwHostDataIDs = Object.freeze({
        FRESH_CHAT: 2,
        PLAYER_FAVORITE_GAMES: 3,
    });

    const PlatformIdsEnum = Object.freeze({
        WEB: 1,
        ANDROID: 2,
        IOS: 3,
        MOBILE_WEB: 4,
    });

    const PamInstanceUrlTypesEnum = Object.freeze({
        CMS_ADAPTER: '1',
        PAM_EXTERNALSERVICES: '2',
        PAM_ASGWEBAPI: '3',
        PAM_WEBAPI: '4',
        PAM_ASG_RESTAPI: '5',
        PAM_GAME_SERVER: '6',
        PAM_INFO_PAGES_SERVER: '7',
    });

    const CookieNames = Object.freeze({
        PLAYER_NG_STATUS: 'playerStatusByNg',
        PLAYER_COUNTRY_CODE: 'playerCountryCode',
        PLAYER_REGULATION_TYPE: 'playerRegulationType',
        PLAYER_CURRENCY_CODE: 'playerCurrencyCode',
        COUNTRY_REGULATION: 'countryRegulation',
        IS_REGISTERED: 'isRegistered',
        VIP_LEVEL: 'fc_vlvl',
        FC_KA_COUNT: 'fcKeepSessionAliveCount',
        APP_ENV: 'APP_ENV',
        PAM_ENV: 'PAM_ENV',
        CDN_HOST: 'CDN_HOST',
        FNC_HOST: 'FNC_HOST',
        SOLAR_HOST: 'SOLAR_HOST',
        GATEWAY_HOST: 'GATEWAY_HOST',
        PAM_ASGWEBAPI_HOST: 'PAM_ASGWEBAPI_HOST',
        IS_NATIVE_APP: 'isnative',
        IS_NATIVE_SSO_APP: 'isnativesso',
    });

    const EnvVars = Object.freeze({
        DEV: 'dev',
        QA: 'qa',
        UAT: 'uat',
        PROD: 'prod',
    });

    const GameVerticalCodesEnum = Object.freeze({
        CASINO: 'casino',
        SPORT: 'sport',
        BINGO: 'bingo',
    });

    // IDs of verticals on platform side
    const GameVerticalCodeToIdEnum = Object.freeze({
        CASINO: 246,
        SPORT: 248,
        BINGO: 244,
    });

    const GameVerticalIdToCodeEnum = Object.freeze({
        [GameVerticalCodeToIdEnum.CASINO]: GameVerticalCodesEnum.CASINO,
        [GameVerticalCodeToIdEnum.SPORT]: GameVerticalCodesEnum.SPORT,
        [GameVerticalCodeToIdEnum.BINGO]: GameVerticalCodesEnum.BINGO,
    });

    const SmartFooterIconsSizeModesEnum = Object.freeze({
        DEFAULT: 1,
        RESIZED_REGULATIONS: 2,
    });

    const chatEventsEnum = Object.freeze({
        INIT: 'StartingChat',
        READY: 'ChatReady',
    });
    // endregion

    const loadCountryData = async () => {
        const response = await getCountry(getIp());
        const data = response?.data;
        if (!data) {
            return;
        }

        const defaultRegulation = 'MGA';

        const {
            countryCode,
            regulation,
            currency: currencyCode,
            countryName: countryNameResponse,
        } = data;

        const countryCodeLowered = countryCode?.toLowerCase() || '';

        currency = currencyCode || '';
        country = countryCodeLowered === 'gb' ? 'uk' : countryCodeLowered;
        isoCountry = countryCodeLowered;
        countryName = countryNameResponse || '';

        detectedRegulation = regulation || defaultRegulation;
    };

    const loadBrandData = async () => {
        try {
            const brandInitResponse = await brandInitRequest();
            setBrandInit(brandInitResponse);
            setRbcSettings(brandInitResponse);
        } catch (err) {
            Tools.error('Failed to load brand data', err);
        }
    };

    const init = async function (preferences) {
        setFrameworkPreferences(preferences);
        await loadCountryData();
        await loadBrandData();

        appendPamFw();

        if (isActiveAppealingToChildrenFilter()) {
            getNotPresentGamesData();
        }

        /*
         * Retrieve RBC settings.
         */
        retrieveRbcSettings().then(() => {
            if (isFreshChatActive() || five9ChatActive()) {
                addChatScript();
            }
            // Embed Datadog RUM
            Tools.embedDatadogRum()
                .then(updateDatadogSessionDetails, Tools.log);
            // Init Dictionaries
            Dictionary.init();
        });

        liveCasinoBetLimitsRequest().then((liveCasinoBetLimitsResponse) => {
            liveCasinoBetLimits = liveCasinoBetLimitsResponse;
        }, Tools.error);

        // add Events for banners
        setBannersEvents();
    };

    const setBannersEvents = () => {
        document.removeEventListener('ASGSegmentedBannersReady', onSegmentedBannersReady);
        document.removeEventListener('AspireEngageBannersData', onEngageBannersReady);

        document.addEventListener('ASGSegmentedBannersReady', onSegmentedBannersReady);
        document.addEventListener('AspireEngageBannersData', onEngageBannersReady);
        document.addEventListener('justLoggedIn', onLoginPurgeEngageBanners);
        document.addEventListener('justLoggedOut', onLoginPurgeEngageBanners);

        // fires after two banners events
        Promise.all([new Promise(resolve => {
            document.removeEventListener('ASGSegmentedBannersReady', resolve);
            document.addEventListener('ASGSegmentedBannersReady', resolve, { once: true });
        }), new Promise(resolve => {
            document.removeEventListener('AspireEngageBannersData', resolve);
            document.addEventListener('AspireEngageBannersData', resolve, { once: true });
        })]).then(() => {
            document.dispatchEvent(new Event('ASGBannersReady'));
        });
    };

    const setBingoEvents = () => {
        bingo.setOnLobbyOpened(() => {
            document.dispatchEvent(new Event('fw_bingoLobbyOpened'));
        });

        bingo.setOnRoomOpened(() => {
            document.dispatchEvent(new Event('fw_bingoRoomOpened'));
        });

        bingo.setOnSoundStateChange((isSoundOn) => {
            document.dispatchEvent(new CustomEvent('fw_bingoSoundStateUpdated', {
                detail: isSoundOn,
            }));
        });
    };

    const onSegmentedBannersReady = () => {
        Tools.log('Segmented (AspireCore) banners are ready', getSegmentedBannersWeb());
    };

    const onEngageBannersReady = (data) => {
        Tools.log('Aspire Engage banners are ready', data.detail);
        if (data.detail) {
            aspireEngageBanners = replaceBannersByCarouselType(aspireEngageBanners, data.detail);
            if (isLoggedIn()) {
                const asgBannersTTL = 24 * 3600 * 1000; // 24 hours
                LocalstorageTTLService.set(
                    getASGBannersCacheKey(),
                    aspireEngageBanners,
                    asgBannersTTL,
                );
                Tools.log('Aspire Engage banners are cached', { userID: getEncryptedUserID() });
            }
        } else {
            Tools.log('Error getting Aspire Engage banners', data);
        }
    };

    /**
     * Searches banners of carousel type from payload
     * and replaces only them in existing banners collection
     */
    const replaceBannersByCarouselType = (existingBannersList, newBannersPayload) => {
        // if payload is empty - return existing list unchanged
        if (
            !newBannersPayload
            || (Array.isArray(newBannersPayload) && newBannersPayload.length === 0)
        ) {
            return existingBannersList;
        }

        // if existing list is empty - just assign new payload
        if (
            !existingBannersList
            || (Array.isArray(existingBannersList) && existingBannersList.length === 0)
        ) {
            return newBannersPayload;
        }

        // if existing banners list is not empty
        // - search banners of carousel type from payload and replace only them
        // assuming payload will always have only 1 type of carousel
        const carouselTypeToUpdate = newBannersPayload[0].carousel_type;

        // filter exsisting banners by carousel type
        const bannersListFilterd = existingBannersList.filter(
            (banner) => banner.carousel_type !== carouselTypeToUpdate,
        );

        return [
            ...bannersListFilterd,
            ...newBannersPayload,
        ];
    };

    const onLoginPurgeEngageBanners = () => {
        // clear Aspire Engage banners
        aspireEngageBanners = null;
    };

    /**
     * checks if need filtered appealing-to-children of game list on pre login for DK and UK
     * @returns {boolean}
     */
    const isActiveAppealingToChildrenFilter = () => !isLoggedIn() && (isBrandDK() || isBrandGb());

    /**
     * Inject AspireEngage scripts
     * @param target
     * @param token
     * @param websitePushID
     * @param inputSpaReloadingConfig
     */
    const initAspireEngage = function (
        target,
        token,
        websitePushID = '',
    ) {
        // if token was not configured don't render a script
        if (!token) {
            return;
        }

        // Should be always true and in global scope.
        window.webxpClientReactExperimentalSupport = true;

        const apiTarget = target;
        const apiTokenPar = token;

        let addExtraPramsToObject = {};
        if (websitePushID !== '') {
            addExtraPramsToObject = {
                push: {
                    safari: {
                        websitePushID,
                    },
                },
            };
        }

        // SPA reloading config
        addExtraPramsToObject.spa_reloading = {
            on_hash_change: true,
            on_url_change: true,
            banners: true,
            experiments: true,
            tags: true,
            visits: true,
            automatic_tracking: true,
        };

        /* eslint-disable */
        !function(e,n,t,i,o,r){function c(e){if("number"!=typeof e)return e;const n=new Date;return new Date(n.getTime()+1e3*e)}function s(e){return e.reduce((function(e,n){return e[n]=function(){e._.push([n.toString(),arguments])},e}),{_:[]})}function a(e,n,t){const i=t.createElement(n);i.src=e;const o=t.getElementsByTagName(n)[0];return o.parentNode.insertBefore(i,o),i}function p(e){return"[object Date]"===Object.prototype.toString.call(e)}r.target=r.target||"https://api.exponea.com",r.file_path=r.file_path||`${r.target}/js/exponea.min.js`,o[n]=s(["anonymize","initialize","identify","update","track","trackLink","trackEnhancedEcommerce","getHtml","showHtml","showBanner","showWebLayer","ping","getAbTest","loadDependency","getRecommendation","reloadWebLayers"]),o[n].notifications=s(["isAvailable","isSubscribed","subscribe","unsubscribe"]),o[n].snippetVersion="v2.3.0",function(e,n,t){e[n][`_${t}`]={},e[n][`_${t}`].nowFn=Date.now,e[n][`_${t}`].snippetStartTime=e[n][`_${t}`].nowFn()}(o,n,"performance"),function(e,n,t,i,o,r){e.webxpClient={sdk:e[i],sdkObjectName:i,skipExperiments:!!t.new_experiments,sign:`${t.token}/${(r.exec(n.cookie)||["","new"])[1]}`,path:t.target}}(o,e,r,n,0,RegExp("__exponea_etc__=([\\w-]+)")),function(e,n,t){a(e.file_path,"script",t)}(r,0,e),function(e,n,t,i,o,r,s){if(e.new_experiments){let i;!0===e.new_experiments&&(e.new_experiments={});const o=e.new_experiments.hide_class||"xnpe_async_hide",u=e.new_experiments.timeout||4e3,l=encodeURIComponent(r.location.href.split("#")[0]);e.cookies&&e.cookies.expires&&("number"==typeof e.cookies.expires||p(e.cookies.expires)?i=c(e.cookies.expires):e.cookies.expires.tracking&&("number"==typeof e.cookies.expires.tracking||p(e.cookies.expires.tracking))&&(i=c(e.cookies.expires.tracking))),i&&i<new Date&&(i=void 0);var m=`${e.target}/webxp/${n}/${r[t].sign}/modifications.min.js?http-referer=${l}&timeout=${u}ms${i?`&cookie-expires=${Math.floor(i.getTime()/1e3)}`:""}`;"sync"===e.new_experiments.mode&&r.localStorage.getItem("__exponea__sync_modifications__")?function(e,n,t,i,o){t[o][n]=`<${n} src="${e}"></${n}>`,i.writeln(t[o][n]),i.writeln(`<${n}>!${o}.init && document.writeln(${o}.${n}.replace("/${n}/", "/${n}-async/").replace("><", " async><"))</${n}>`)}(m,n,r,s,t):function(e,n,t,i,o,r,c,s){r.documentElement.classList.add(e);var p=a(t,i,r);function m(){o.webxpClient.init||a(t.replace(`/${i}/`,`/${i}-async/`),i,r)}function u(){r.documentElement.classList.remove(e)}p.onload=m,p.onerror=m,o.setTimeout(u,n),o.exponea._revealPage=u}(o,u,m,n,r,s)}}(r,t,i,0,0,o,e),function(e,n,t){e[n].start=function(i){i&&Object.keys(i).forEach((function(e){return t[e]=i[e]})),e[n].initialize(t)}}(o,n,r)}(document, 'exponea', 'script', 'webxpClient', window, {
            target: apiTarget,
            token: apiTokenPar,
            new_experiments: { mode: "async" },
            track: { visits: !0 },
            ...addExtraPramsToObject
        });
        /* eslint-enable */

        window.exponea.start();

        Tools.log('Aspire Engage has started', webxpClient);
    };

    /**
     * Data for Example
     * @type {*[]}
     */
    const JackpotGameList = [{
        gameId: 469,
        identifier: 0,
    }];

    const getLanguage = () => Language;

    const getAsgSrvEnvOverride = () => asgSrvEnvOverride;

    const getBrandID = () => brandID;

    const getBrandDomain = () => BrandDomain;

    const getAppEnv = () => appEnv;

    const getPamEnv = () => pamEnv;

    const getCdnHost = () => cdnHost;

    const getFncHost = () => fncHost;

    const getSolarHost = () => solarHost;

    const getGatewayHost = () => gatewayHost;

    const getPamAsgWebApiHost = () => pamAsgWebApiHost;

    const getVersion = () => version;

    const isAsgHosted = () => asgHosted;

    /**
     * Brand domain with env prefix
     * @returns {`${string}${string}`}
     */
    const getBrandDomainWithEnvPrefix = () => `${Tools.getEnvPrefix()}${getBrandDomain()}`;

    /**
     * Checks if "neoCmsIntegration" is configured
     * @returns {boolean}
     */
    const isNeoCmsIntegrationEnabled = () => getRbcSettings('neoCmsIntegration') || false;

    const getPamFwUrl = () => {
        if (pamFwUrl) {
            return pamFwUrl;
        }

        let env;
        const pamEnv = getPamEnv();
        if (pamEnv) {
            env = pamEnv === EnvVars.PROD ? '' : `${pamEnv}.`;
        } else {
            Tools.error('pamEnv parameter not passed into preferences on init');
            env = getGameserverPrefix();
        }

        const genericOrigin = `https://gamesrv1.${env}${BrandDomain}`;
        const pamGameServerUrl = isNeoCmsIntegrationEnabled()
            && getPamUrls(PamInstanceUrlTypesEnum.PAM_GAME_SERVER);
        const gameServerOrigin = pamGameServerUrl || genericOrigin;

        return `${gameServerOrigin}/MWC/mwc-app.js`;
    };

    const appendPamFw = async function () {
        Tools.track('NGLoad:start');

        const mwcUrl = getPamFwUrl();
        Tools.appendJS(mwcUrl);
        Tools.log('The platform is appended', { url: mwcUrl, config: window.getFrameworkPreferences() });
    };

    const getFrameworkUri = function () {
        return getFncHost()
            ? `https://${getFncHost()}/asg-framework/`
            : `https://fnc.${getAsgServerPrefix()}aspireglobal.com/asg-framework/`;
    };

    const getAsgAPIUri = function () {
        return getFncHost()
            ? `https://${getFncHost()}/services/asgapi/`
            : `https://fnc.${getAsgServerPrefix()}aspireglobal.com/services/asgapi/`;
    };

    const getIp = function () {
        return Tools.getParameters(Tools.getNavUrl()).ip ? Tools.getParameters(Tools.getNavUrl()).ip : '';
    };

    /**
     * @deprecated
     */
    const getGameserverPrefix = function () {
        const param = window.UrlService.getParams('env');
        let env;

        // use env param to determine the environment, can only be used on qa and dev
        const getEnvPrefix = Tools.getEnvPrefix();
        const validPrefixes = ['dev.', 'qa.', 'uat.'];
        const validEnv = ['prod', 'dev', 'qa', 'uat'];

        if (gameSrvEnvOverride && validEnv.indexOf(gameSrvEnvOverride) !== -1) {
            // config param from green backend
            env = `${gameSrvEnvOverride}.`;
        }

        if (validPrefixes.includes(getEnvPrefix)) {
            // GET param from URL
            if (param) {
                if (param.value === 'prod') {
                    env = '';
                } else if ((validEnv.indexOf(param.value) !== -1)) {
                    env = `${param.value}.`;
                } else {
                    env = undefined;
                }
            }
        }

        const envPrefix = env !== undefined ? env : Tools.getEnvPrefix();

        return (envPrefix === 'dev.' || envPrefix === 'qa.' || envPrefix === 'uat.') ? 'qa.' : '';
    };

    /**
     * @deprecated
     */
    const getAsgServerPrefix = function () {
        let env;
        const getEnvPrefix = Tools.getEnvPrefix();
        const param = window.UrlService.getParams('env');
        const validPrefixes = ['dev.', 'qa.', 'uat.'];
        const validEnv = ['prod', 'dev', 'qa', 'uat'];

        if (asgSrvEnvOverride && validEnv.indexOf(asgSrvEnvOverride) !== -1) {
            env = `${asgSrvEnvOverride}.`;
        } else {
            env = getEnvPrefix;
        }

        // Use env param to determine the environment, can only be used on qa and dev
        if (validPrefixes.includes(getEnvPrefix)) {
            // GET param from URL
            if (param) {
                if (param.value === 'prod') {
                    env = '';
                } else if ((validEnv.indexOf(param.value) !== -1)) {
                    env = `${param.value}.`;
                } else {
                    env = undefined;
                }
            }
        }

        return (env && validPrefixes.includes(env)) ? env : '';
    };

    const getDsEnv = function () {
        const envPrefix = Tools.getEnvPrefix();
        const dsEnv = [];
        if (envPrefix === '' || envPrefix === 'www.') {
            dsEnv.prefixASG = '';
            dsEnv.prefixNG = '';
            dsEnv.location = dsProd;
        } else if (envPrefix === 'uat.') {
            dsEnv.prefixNG = 'qa.';
            dsEnv.prefixASG = 'uat.';
            dsEnv.location = dsUat;
        } else if (envPrefix === 'qa.' || envPrefix === 'dev.') {
            dsEnv.prefixNG = 'qa.';
            dsEnv.prefixASG = 'qa.';
            dsEnv.location = dsQa;
        }
        return dsEnv;
    };

    const setFrameworkPreferences = function (preferences) {
        // eslint-disable-next-line no-unused-vars
        appEnv = Cookie.read(CookieNames.APP_ENV) || preferences.appEnv || '#{APP_ENV}#';
        pamEnv = Cookie.read(CookieNames.PAM_ENV) || preferences.pamEnv || '#{PAM_ENV}#';
        cdnHost = Cookie.read(CookieNames.CDN_HOST) || preferences.cdnHost || '#{CDN_HOST}#';
        fncHost = Cookie.read(CookieNames.FNC_HOST) || preferences.fncHost || '#{FNC_HOST}#';
        solarHost = Cookie.read(CookieNames.SOLAR_HOST) || preferences.solarHost || '#{SOLAR_HOST}#';
        gatewayHost = Cookie.read(CookieNames.GATEWAY_HOST) || preferences.gatewayHost || '#{GATEWAY_HOST}#';
        pamAsgWebApiHost = Cookie.read(CookieNames.PAM_ASGWEBAPI_HOST)
            || preferences.pamAsgWebApiHost || '#{PAM_ASGWEBAPI_HOST}#';
        asgHosted = preferences.isAsgHosted || false;
        version = preferences.version || '#{Build.BuildNumber}#';
        pamFwUrl = preferences.platformFrameworkUrl;
        brandID = preferences.BrandID;
        Language = preferences.Language || 'ENG';
        // eslint-disable-next-line no-param-reassign
        preferences.loadSport = (typeof preferences.loadSport === 'undefined')
            ? true : preferences.loadSport;
        isShowOnlyWinnersOfThisBrand = preferences.isShowOnlyWinnersOfThisBrand || false;

        const ngFramework = {
            BrandID: brandID,
            Language,
            Platform: preferences.Platform || 'W', // Bonus: Mobile detect and auto transfer
            URLParams: preferences.URLParams || '', // Bonus: Auto take from URL
            balanceUpdateUkMode: preferences.balanceUpdateUkMode || false,
            IsGameStandaloneMode: (typeof preferences.IsGameStandaloneMode === 'undefined') ? true : preferences.IsGameStandaloneMode,
        };

        // don't pass hooks to NG unless sport iframe required to show
        // no hooks = no internal overload for other pages
        if (preferences.loadSport !== false) {
            ngFramework.hooks = { onFetch };
        }

        BrandDomain = preferences.BrandDomain;
        OpenPageFunc = preferences.OpenPageFunc;
        // eslint-disable-next-line no-unused-vars
        CurrencyCode = preferences.Currency;
        pamPlatform = preferences.Platform;
        gameSrvEnvOverride = preferences.gameSrvEnvOverride;
        asgSrvEnvOverride = preferences.asgSrvEnvOverride;
        window.getFrameworkPreferences = function () {
            return ngFramework;
        };
    };

    // on fetch set ngApiReady trigger
    const onFetch = function (data) {
        ngApi = data;
        document.dispatchEvent(new Event('ngApiReady'));
    };

    const getFetchData = function () {
        return ngApi;
    };

    /**
     * Old Jackpot solution (deprecated)
     * @param callback
     * @deprecated
     */
    function getJackpotData(callback) {
        const currency = getDisplayBalance().Currency;
        fetch(`https://asgwebapi.${getAsgServerPrefix()}gameserver1-mt.com/api/pjp/getprogressivejackpots?CurrencyCode=${currency}`)
            .then(response => response.json())
            .then(data => {
                if (data.ErrorCode === 0) {
                    callback(data);
                } else {
                    callback({ error: true });
                }
            });
    }

    /**
     * Returns player's regulation or geo-detected regulation.
     * @returns string
     */
    const getRegulation = () => {
        let regulation = getDetectedRegulation();
        const cookieRegulation = Cookie.read(CookieNames.PLAYER_REGULATION_TYPE);
        const playerIsLoggedIn = Cookie.read(CookieNames.PLAYER_NG_STATUS);
        if (isLoggedIn()) {
            regulation = ngRegulationToAsg(getPlayerRegulationType());
        } else if (playerIsLoggedIn && cookieRegulation) {
            regulation = cookieRegulation;
        }
        return regulation;
    };

    const getPlayerRegulationType = function () {
        if (window.ng_fw && isLoggedIn()) {
            const sessionDetails = window.ng_fw.getSessionDetails();

            if (Object.prototype.hasOwnProperty.call(sessionDetails, 'PlayerRegulationType')) {
                return sessionDetails.PlayerRegulationType;
            }
        }

        return getDetectedRegulation();
    };

    const getDetectedRegulation = () => detectedRegulation;

    /**
     * Return Regulation code by client country
     * @returns {string}
     * @deprecated
     */
    const getRegulationByCountry = function () {
        let regulation;
        switch (country) {
        case 'uk':
            regulation = 'gb';
            break;
        case 'dk':
            regulation = 'dk';
            break;
        case 'de':
            regulation = 'de';
            break;
        case 'nl':
            regulation = 'nl';
            break;
        default:
            regulation = 'mga';
        }
        return regulation;
    };

    const getPlayerCountryCode = function () {
        let playerCountryCode = null;
        if (isLoggedIn()) {
            const sessionDetails = window.ng_fw.getSessionDetails();
            const hasCountryCode = Object.prototype.hasOwnProperty.call(sessionDetails, 'CountryCode');
            playerCountryCode = hasCountryCode ? sessionDetails.CountryCode : '';
        }
        return playerCountryCode;
    };

    /**
     * Old Jackpot solution (deprecated)
     * @param callback
     * @deprecated
     */
    const setGetJackpots = function (callback) {
        getJackpotData(function (data) {
            const result = [];
            if (!data.error) {
                JackpotGameList.forEach(function (item) {
                    const temp = {
                        gameId: item.gameId,
                        PJPBalanceCurrent:
                        data.ProgressiveJackpots[item.identifier].PJPBalanceCurrent,
                        CurrencyCode: data.ProgressiveJackpots[item.identifier].CurrencyCode,
                    };
                    result.push(temp);
                });
                callback(result);
            } else {
                callback({ error: true });
            }
        });
    };

    const showLogin = function () {
        lastAction = 'Login';
        window.ng_fw.showLogin();
    };

    const showRegistration = function (paramsObj) {
        lastAction = 'Registration';
        window.ng_fw.showRegistration(paramsObj);
        document.dispatchEvent(new Event('showRegistration'));
    };

    const showDeposit = function () {
        lastAction = 'Deposit';
        window.ng_fw.showDeposit();
    };

    // region Chat manipulations

    /**
     * Adds propper chat script and style to the DOM.
     */
    const addChatScript = function () {
        // FC v1 by default
        let chatScriptSrc = `${getFrameworkUri()}js/fresh-chat.min.js?v=${getVersion()}`;

        if (five9ChatActive()) {
            chatScriptSrc = 'https://app.five9.com/consoles/SocialWidget/five9-social-widget.min.js';
        } else if (isFreshChatV2Active()) {
            chatScriptSrc = `${getFrameworkUri()}js/fresh-chat-v2.min.js?v=${getVersion()}`;
        }

        Tools.getScript(chatScriptSrc, () => {
            Tools.log('Chat script added');
        });

        addChatStyle();
    };

    const addChatStyle = function () {
        if (isFreshChatActive()) {
            const chatStyle = `${getFrameworkUri()}components/chat/fresh-chat.css?v=${getVersion()}`;
            Tools.appendCss(chatStyle);
        }
    };

    const chatRequiresLogin = function () {
        return AsgFW.getRbcSettings('chatRequiresLogin');
    };

    const initFive9Chat = function (preferences) {
        const defaultSettings = {
            rootUrl: 'https://app.five9.com/consoles/',
            type: 'chat',
        };
        const options = {
            ...defaultSettings,
            ...preferences,
        };

        const isChatEnabled = isLoggedIn() || !chatRequiresLogin();
        const widgetExists = !!window.Five9SocialWidget;

        if (isChatEnabled && widgetExists) {
            window.Five9SocialWidget.addWidget(options);
            document.body.classList.add('five9-chat-added');
        }
    };

    /**
     * Initializes FreshChat from API
     * @link https://aspireglobal.atlassian.net/wiki/spaces/ASG/pages/178258065/initChat
     * @param {object} preferences
     * @param {string} preferences.siteLanguage
     * @param {object} preferences.preChatTexts
     * @param {object} preferences.uiTexts
     * @param {bool} [preferences.openOnLoad]
     * @param {array} [preferences.customChatEventHandlers]
     * @param {array} [preferences.customDataCollectors]
     */
    const initChat = function (preferences) {
        if (!Object.hasOwn(preferences, 'siteLanguage')
            || !Object.hasOwn(preferences, 'preChatTexts')
            || !Object.hasOwn(preferences, 'uiTexts')
        ) {
            const errorMessage = 'Cannot init chat because some required preferences are missing.';
            Tools.error(errorMessage, preferences);
            return;
        }

        const data = brandInitData && brandInitData.data;

        const bgColor = data && data.fcBackgroundColor;
        const fgColor = data && data.fcForegroundColor;
        const customUserProperties = getRbcSettings('freshChatCustomUserProperties');

        let chatConfig = {};
        const chatParams = {};

        if (isFreshChatV2Active()) {
            chatConfig = getRbcSettings('freshChatV2Configuration');
            chatParams.widgetId = chatConfig?.id;
            chatParams.widgetSource = chatConfig?.url;
        } else if (isFreshChatV1Active()) {
            chatConfig = getRbcSettings('freshChatConfiguration');
            chatParams.token = chatConfig?.token;
            chatParams.host = chatConfig?.url;
            chatParams.cfPrefix = chatConfig?.cfPrefix || false;
        } else {
            Tools.error('Cannot init FreshChat because the configuration is missing.');
            return;
        }

        Object.assign(chatParams, {
            customUserProperties,
            brandName: getBrandName(),
            brandDomain: BrandDomain.toLowerCase(),
            bgc: bgColor || '',
            fgc: fgColor || '',
            locale: preferences.siteLanguage,
            preChatTexts: preferences.preChatTexts,
            uiTexts: preferences.uiTexts,
            predictedVIP: window.Cookie.read(CookieNames.VIP_LEVEL),
        });

        if (Object.hasOwn(chatConfig, 'hideFileUpload')) {
            chatParams.hideFileUpload = chatConfig.hideFileUpload;
        }
        if (Object.hasOwn(chatConfig, 'widgetUuid')) {
            chatParams.widgetUuid = chatConfig.widgetUuid;
        }

        if (Object.hasOwn(preferences, 'openOnLoad')) {
            chatParams.openOnLoad = preferences.openOnLoad;
        }
        if (Object.hasOwn(preferences, 'customChatEventHandlers')) {
            chatParams.customChatEventHandlers = preferences.customChatEventHandlers;
        }
        if (Object.hasOwn(preferences, 'customDataCollectors')) {
            chatParams.customDataCollectors = preferences.customDataCollectors;
        }

        window.AsgChat.initChat(chatParams);
    };

    const showChat = function () {
        if (five9ChatActive()) {
            openFive9Chat();
        } else if (isFreshChatActive()) {
            openFreshChat();
        } else {
            window.ng_fw.showChat();
        }
    };

    const five9ChatActive = function () {
        return !!AsgFW.getRbcSettings('five9ChatConfig');
    };

    /**
     * Checks if any of the FC versions are active.
     * @return {*}
     */
    const isFreshChatActive = function () {
        return isFreshChatV1Active() || isFreshChatV2Active();
    };

    const isFreshChatV1Active = function () {
        return !!getRbcSettings('freshChatConfiguration');
    };

    const isFreshChatV2Active = function () {
        return !!getRbcSettings('freshChatV2Configuration');
    };

    const openFive9Chat = function () {
        if (window.Five9SocialWidget) {
            const chatOptions = window.Five9SocialWidget.options;
            window.Five9SocialWidget.maximizeChat(chatOptions);
        }
    };

    const openFreshChat = function () {
        if (window.fcWidget) {
            window.fcWidget.open();
        } else {
            Tools.error('FreshChat not ready');
        }
    };

    const isChatOpen = function () {
        let isChatOpen = false;
        if (five9ChatActive()) {
            isChatOpen = window.Five9SocialWidget.data.state === 'maximized';
        } else if (window.fcWidget) {
            isChatOpen = window.fcWidget.isOpen();
        }

        return isChatOpen;
    };

    const closeChat = function () {
        // eslint-disable-next-line no-unused-expressions
        window.fcPreChatform && window.fcPreChatform.on_fc_pre_form_close
        && window.fcPreChatform.on_fc_pre_form_close();
        if (window.fcWidget) {
            window.fcWidget.close();
        }
    };

    /**
     * Keep NG session alive while FreshChat is open
     */
    const startMeasureSessionTime = function () {
        const defaultTimeoutMilliseconds = 30000;
        startFreshChatCalc(defaultTimeoutMilliseconds);
    };

    /**
     * Calc how much time and when to keep NG session alive
     * @param data
     */
    const startFreshChatCalc = (chatTimeOutMillisecond) => {
        let fireCount = null;
        let sec = 0;
        let remainder = 0;
        let divide = 1;
        const isKeepaliveActive = getRbcSettings('add_keepalive');

        if (chatTimeOutMillisecond > 0) {
            divide = chatTimeOutMillisecond / keepAliveInterval;
            fireLimit = Math.floor(divide);
            remainder = divide - fireCount - 1;
        }

        const cookieKey = CookieNames.FC_KA_COUNT;

        if (!measureTimerInterval && isLoggedIn()) { // check if timer already working
            let timestamp = Math.round(new Date().getTime() / 1000); // current timestamp

            measureTimerInterval = setInterval(function () { // set interval every 1 second
                if (!window.Cookie.read(cookieKey) || sec === 0) { // check if cookie counter exist
                    // if not exist
                    fireCount = 1; // init counter - the number of times the session refreshed
                } else {
                    // if cookie exist
                    fireCount = window.Cookie.read(cookieKey);
                }

                window.Cookie.create(cookieKey, fireCount * 1, '1');// set counter | save cookie for 1 day
                sec += 1; // add 1 second to timer
                const curTime = Math.round(new Date().getTime() / 1000); // get current time

                // check if under amount of limits time of session refreshed
                if (curTime > (timestamp + (keepAliveInterval / 1000))
                    && fireCount < (fireLimit + remainder)) {
                    if (window.fcWidget.isOpen()) { // check if Freshchat widget is open
                        // Freshchat widget is open and more
                        timestamp = Math.round(new Date().getTime() / 1000); // reset timestamp
                        fireCount = fireCount * 1 + 1; // add to counter
                        window.ng_fw.keepAlive(); // keep NeoGame session alive
                        if (fireCount >= fireLimit) {
                            keepAliveInterval *= remainder;
                        }
                    } else { // if Freshchat widget is closed
                        fireCount = 1; // reset counter
                    }

                    window.Cookie.create(cookieKey, fireCount * 1, '1');// save cookie for 1 day
                } else if (fireCount >= fireLimit + Math.ceil(remainder)
                    && curTime > (timestamp + (keepAliveInterval / 1000))) {
                    // stop measuring
                    timestamp = Math.round(new Date().getTime() / 1000);

                    /**
                     * check if need set keepAlive
                     * flag by RBC setting
                     */
                    if (isKeepaliveActive) {
                        window.ng_fw.keepAlive(); // keep NeoGame session alive last time
                    }
                    destroyTimeCounter(); // stop set interval
                }
            }, 1000);
        }
    };

    /**
     * Destroy time counter
     */
    function destroyTimeCounter() {
        clearInterval(measureTimerInterval);
    }

    /**
     * If NG logout then destroy measureTimerInterval
     */
    document.addEventListener('justLoggedOut', function () {
        destroyTimeCounter();
    });

    // endregion

    const showContactUs = function (options) {
        let localOptions = options;
        if (typeof localOptions !== 'object') {
            /*
            if has default param. in window.asgContactUsBrandParameters set this param.
            else set empty obj
            */
            const asgContactUsBrandParameters = Object.prototype.hasOwnProperty.call(window, 'asgContactUsBrandParameters');
            localOptions = asgContactUsBrandParameters ? window.asgContactUsBrandParameters : {};
        }
        // open new default contact us widget
        AsgFW.showAsgContactUs(localOptions);
        // ng_fw.showContactUs();
        return false;
    };

    /**  NG Wrappers - Start */
    const showDepositLimit = function () {
        window.ng_fw.showDepositLimit();
    };

    const showMyAccount = function () {
        window.ng_fw.showMyAccount();
    };

    const showChangePassword = function () {
        window.ng_fw.showChangePassword();
    };

    const showSelfExclusion = function () {
        window.ng_fw.showSelfExclusion();
    };

    const showGamesHistory = function () {
        window.ng_fw.showGamesHistory();
    };

    const showTransactionsHistory = function () {
        window.ng_fw.showTransactionsHistory();
    };

    const closeGame = function () {
        window.ng_fw.closeGame();
    };

    const showWithdraw = function () {
        window.ng_fw.showWithdraw();
    };

    const showMyRewards = function () {
        window.ng_fw.showMyRewards();
    };

    const showRealityCheck = function () {
        window.ng_fw.showRealityCheck();
    };

    const showLoginHistory = function () {
        window.ng_fw.openLoginHistory();
    };

    const logout = function () {
        window.ng_fw.logout();
    };

    const keepAlive = function () {
        window.ng_fw.keepAlive();
    };

    const showCoolOff = function () {
        window.ng_fw.showCoolOff();
    };

    /**
     * close game before loadGame for German or UK players
     * @param gameID
     * @param playMode
     */
    const closeAndLoadGame = (gameID, playMode) => {
        if (isLoggedIn() && (isPlayerDECountry() || isUkRegulation())) {
            tryCloseAndLoadGame('game', gameID, playMode);
        } else {
            loadGame(gameID, playMode);
        }
    };

    /**
     * @deprecated use AsgFW.closeAndLoadGame()
     */
    const closeAdnLoadGame = (gameID, playMode) => {
        Tools.error('Deprecated, use AsgFW.closeAndLoadGame()');

        closeAndLoadGame(gameID, playMode);
    };

    /**
     * return TRUE if player country == DE
     * @returns {boolean}
     */
    const isPlayerDECountry = () => {
        if (isLoggedIn()) {
            const playerDetails = getSessionDetails();
            return playerDetails.CountryCode === 'DE';
        }
        return false;
    };

    /**
     * When load a game, opened one will be closed underhood.
     * But just in case, call closeGame() to not broke some old logic.
     *
     * @param gameType 'bingo' or any other string.
     * @param gameID
     * @param playMode Optional.
     */
    const tryCloseAndLoadGame = function (gameType, gameID, playMode = '') {
        closeGame();

        try {
            if (gameType === GameVerticalCodesEnum.BINGO) {
                window.ng_fw.loadBingo({
                    gameId: gameID,
                });
            } else {
                loadGame(gameID, playMode);
            }
        } catch (e) {
            const errorMessage = `Failed to load ${gameType} #${gameID} ${playMode}`;
            Tools.error(errorMessage, e);
        }
    };

    const loadGame = function (gameID, playMode) {
        window.ng_fw.loadGame(gameID, playMode);
    };

    const showDocumentUpload = function () {
        window.ng_fw.showDocumentUpload();
    };

    const getDisplayBalance = function () {
        const balance = window.ng_fw.getDisplayBalance();
        balance.CurrencySign = AsgFW.getCurrencySignByCode(balance.Currency);

        return balance;
    };

    const getLoyaltyPoints = function () {
        return window.ng_fw.getLoyaltyPoints();
    };

    const isLoggedIn = function () {
        if (!window.ng_fw) return false;
        const sessionDetails = window.ng_fw.getSessionDetails();
        return (sessionDetails !== null && !Object.prototype.hasOwnProperty.call(sessionDetails, 'ErrorCode'));
    };

    const isLoggedInByCookie = () => Boolean(Cookie.read(CookieNames.PLAYER_NG_STATUS));

    const getSessionDetails = function () {
        if (!window.ng_fw) return null;
        const sessionDetails = window.ng_fw.getSessionDetails();
        if (sessionDetails !== null && Object.prototype.hasOwnProperty.call(sessionDetails, 'ErrorCode')) {
            return null;
        }
        return sessionDetails;
    };

    const setGetBannerDetails = function (fnc) {
        return window.ng_fw.getBannerDetails(fnc);
    };

    const getPayNPlayData = function () {
        return window.ng_fw.getPayNPlayData();
    };

    /**
     * Closes Registration widget
     * */
    const closeRegistration = function () {
        return window.ng_fw.closeRegistration();
    };

    /**
     * Closes Login popup
     * */
    const closeLogin = function () {
        return window.ng_fw.closeLogin();
    };

    /**
     * Closes My Account widget
     * */
    const closeMyAccount = function () {
        return window.ng_fw.closeMyAccount();
    };

    /**
     * Closes Deposit widget
     * */
    const closeDeposit = function () {
        return window.ng_fw.closeDeposit();
    };

    /**
     *  Closes all NG widgets.
     */
    const closeAllWidgets = function () {
        return window.ng_fw.closeAllWidgets();
    };

    /**
     * Activates cool off feature for the Player.
     */
    // eslint-disable-next-line consistent-return
    const callTakeABreak = function () {
        const takeABreak = Object.prototype.hasOwnProperty.call(window.ng_fw, 'callTakeABreak');
        if (takeABreak) {
            return window.ng_fw.callTakeABreak();
        }
        logout();
    };
    /**  NG Wrappers - End */

    const getPlayerName = function () {
        if (isLoggedIn()) {
            return window.ng_fw.getSessionDetails().PlayerName;
        }
        return false;
    };

    const getPlayerID = function () {
        if (isLoggedIn()) {
            return window.ng_fw.getSessionDetails().PlayerID;
        }
        return false;
    };

    /**
     * @returns {string|null}
     */
    const getEncryptedUserID = function () {
        if (isLoggedIn()) {
            return window.ng_fw.getSessionDetails().EncryptedUserID;
        }
        return null;
    };

    const getLoginTimeStamp = function () {
        if (isLoggedIn()) {
            return window.ng_fw.getSessionDetails().LoginTimeStamp;
        }
        return null;
    };

    const getLastLoginTimeStamp = function () {
        if (isLoggedIn()) {
            return window.ng_fw.getSessionDetails().LastLoginTimeStamp;
        }
        return null;
    };

    const getServerTimeStamp = function () {
        if (isLoggedIn()) {
            return window.ng_fw.getSessionDetails().ServerTimeStamp;
        }
        return false;
    };

    /**
     * Get player VIP level from NG session
     * @returns {int|*}
     */
    const getPlayerVipLevel = function () {
        if (isLoggedIn()) {
            return window.ng_fw.getSessionDetails().PlayerVipLevel;
        }
        return false;
    };

    /**
     * NG on 'fwReady' event handler.
     */
    document.addEventListener('fwReady', function () {
        Tools.track('NGReadyEvent');

        Tools.track('ASGReadyEvent');
        document.dispatchEvent(new Event('fw_asgReady'));

        setNgHsTrigger();
        setVipLevelCookie(); // save player vip level inside cookie
        updateSessionCookies();

        setSegmentedBannersHandlers();
    });

    const setSegmentedBannersHandlers = () => {
        setGetBannerDetails(setSegmentedBanners);
    };

    const setSegmentedBanners = (data) => {
        const dsEnv = getDsEnv();
        try {
            if (data.BannersTypes === null) {
                segmentedBannersWeb = data.BannersSets[0].Banners;
                bannersReplaceNGtoAzureStorage(dsEnv, segmentedBannersWeb);
                [segmentedBannerMobile] = data.BannersSets[0].Banners;
            } else {
                data.BannersTypes.forEach((el, key) => {
                    switch (data.BannersTypes[key].BannerTypeCode) {
                    case 'PlayerLobbyBanners':
                        segmentedBannersWeb = data.BannersTypes[key].BannersSets[0].Banners;
                        bannersReplaceNGtoAzureStorage(dsEnv, segmentedBannersWeb);
                        [segmentedBannerMobile] = data.BannersTypes[key].BannersSets[0].Banners;
                        break;
                    case 'PlayerSpecialEvents':
                        bannersReplaceNGtoAzureStorage(
                            dsEnv, data.BannersTypes[key].BannersSets[0].Banners,
                        );
                        [segmentedBannerSpecial] = data.BannersTypes[key].BannersSets[0].Banners;
                        break;
                    case 'PlayerPopups':
                        bannersReplaceNGtoAzureStorage(
                            dsEnv, data.BannersTypes[key].BannersSets[0].Banners,
                        );
                        [segmentedBannerPopups] = data.BannersTypes[key].BannersSets[0].Banners;
                        break;
                    default:
                    }
                });
            }
        } catch (e) {
            Tools.log('Error getting Segmented (AspireCore) banners', e);
        }
        document.dispatchEvent(new Event('ASGSegmentedBannersReady'));
    };

    /**
     * @param dsEnv
     * @param banners
     */
    const bannersReplaceNGtoAzureStorage = function (dsEnv, banners) {
        if (dsEnv.location === 'ASG') {
            banners.forEach(function (b) {
                if (b.Source.includes('gamesrv1')) {
                    // eslint-disable-next-line no-param-reassign
                    b.Source = replaceNGtoAzureStorage(b.Source);
                }
            });
        }
    };

    /**
     * Temporary function to help with banners migration to the new Azure storage.
     * TODO: remove the function after NG will update URLs on their side
     */
    const replaceNGtoAzureStorage = function (URL) {
        const dsEnv = getDsEnv();
        const cdnUrl = getCdnHost()
            ? `https://${getCdnHost()}`
            : `https://cdn.${dsEnv.prefixASG}aspireglobal.com`;
        const urlReplaced = URL.replace(`https://download.${dsEnv.prefixNG}gamesrv1.com`, cdnUrl);
        const tmp = urlReplaced.split('/');
        tmp[tmp.length - 1] = tmp[tmp.length - 1].toLowerCase();
        return tmp.join('/');
    };

    /**
     * @return {Object[]}
     */
    const getSegmentedBannersWeb = function () {
        if (!segmentedBannersWeb) {
            return [];
        }
        return Array.isArray(segmentedBannersWeb) ? segmentedBannersWeb : [segmentedBannersWeb];
    };

    /**
     * @return {Object}
     */
    const getSegmentedBannerMobile = function () {
        return Array.isArray(segmentedBannerMobile)
            ? segmentedBannerMobile
            : [segmentedBannerMobile];
    };

    /**
     * @return {Object}
     */
    const getSegmentedBannerSpecial = function () {
        return segmentedBannerSpecial;
    };

    /**
     * @return {Object}
     */
    const getSegmentedBannerPopups = function () {
        return segmentedBannerPopups;
    };

    const isMobilePamPlatform = function () {
        return MOBILE_PAM_PLATFORMS.includes(pamPlatform);
    };

    /**
     * Get RBC (regulation, brand, country)
     * @returns {{country: string, regulation: (*|string), brand}}
     */
    const getRBC = function () {
        const regulation = getRegulation();
        const brand = getBrandID();
        const country = getCurrentCountry().toUpperCase();
        return {
            regulation,
            brand,
            country,
        };
    };

    /**
     * Prepare RBC Settings Cache key.
     * @returns string
     */
    const getRbcSettingsCacheKey = function () {
        const { regulation, brand, country: detectedIsoCountry } = getRBC();
        return `RBCSettings_r:${regulation}_b:${brand}_c:${detectedIsoCountry}`;
    };

    /**
     * Get RBC Settings Session storage data.
     * @returns {any|string}
     */
    const getRbcSettingsSessionStorage = function () {
        const cacheKey = getRbcSettingsCacheKey();
        const value = sessionStorage.getItem(cacheKey);
        return value ? JSON.parse(value) : value;
    };

    /**
     * Set RBC Settings storage data.
     * @param newValue
     */
    const setRbcSettingsSessionStorage = function (newValue) {
        const cacheKey = getRbcSettingsCacheKey();

        if (newValue) {
            sessionStorage.setItem(cacheKey, JSON.stringify(newValue));
        }
    };

    /**
     * Set RBC Settings data - set AsgFW local variable and save to Session storage cache.
     * @param response
     */
    const setRbcSettings = function (response) {
        rbcSettings = response && response.data && response.data.RBCSettings;
        setRbcSettingsSessionStorage(rbcSettings);
    };

    /**
     * Retrieve RBC Settings from Session storage cache or fetch from Solar API.
     * @returns {Promise<unknown>}
     */
    const retrieveRbcSettings = function () {
        return new Promise((resolve, reject) => {
            const RBCSettingsStorage = getRbcSettingsSessionStorage();
            if (!RBCSettingsStorage) {
                fetchRbcSettings()
                    .then(fireRbcSettingsReadyEvent)
                    .then(resolve)
                    .catch(reject);
            } else {
                rbcSettings = RBCSettingsStorage;
                fireRbcSettingsReadyEvent();
                resolve();
            }
        });
    };

    const fireRbcSettingsReadyEvent = () => (new Promise((resolve) => {
        Tools.log('RBC Settings ready');
        document.dispatchEvent(new Event('asgRbcSettingsReady'));
        resolve();
    }));

    /**
     * Fetch RBC Settings from Solar API.
     * @returns {Promise<unknown>}
     */
    const fetchRbcSettings = function () {
        return new Promise((resolve, reject) => {
            const { regulation, brand, country: detectedIsoCountry } = getRBC();
            const requestParams = {
                regulationType: regulation,
                casinoId: brand,
                country: detectedIsoCountry,
            };
            SolarAPI.get(
                '/api/v1/rbc-settings',
                requestParams,
                (response) => {
                    setRbcSettings(response);
                    resolve(response);
                },
                (e) => {
                    console.error('RBC Settings request failed', e);
                    reject(e);
                },
            );
        });
    };

    const getSolarBaseParams = () => {
        const sso = AsgFW.isLoggedIn() || AsgFW.isLoggedInByCookie() ? 1 : 0;

        return {
            platform: getPlatformId(),
            sso,
            regulation: getRegulation(),
            country: getCurrentCountry().toUpperCase(),
        };
    };

    const brandInitRequest = function () {
        return new Promise((resolve, reject) => {
            const brandInitRequestParams = getSolarBaseParams();

            // pass ip address if it's present in query string
            const ip = getIp();
            if (ip) {
                brandInitRequestParams.ip = ip;
            }

            SolarAPI.get(
                '/api/v2/brands/{casinoId}/brand-init',
                brandInitRequestParams,
                (brandInitResponse) => {
                    if (Object.prototype.hasOwnProperty.call(brandInitResponse, 'data')) {
                        resolve(brandInitResponse);
                    } else if (Object.prototype.hasOwnProperty.call(brandInitResponse, 'error')) {
                        throw new Error('Brand init API replied with an error');
                    }
                },
                (e) => {
                    Tools.error('BrandInit request failed', e);
                    reject(e);
                },
            );
        });
    };

    const ngRegulationToAsg = (ngRegulation) => {
        const regulationsMap = {
            '-': 'MGA',
            UK: 'GB',
        };

        const ngRegulationUpdated = ngRegulation.toUpperCase();

        if (Object.keys(regulationsMap).includes(ngRegulationUpdated)) {
            return regulationsMap[ngRegulationUpdated];
        }

        return ngRegulationUpdated;
    };

    const isRegistered = function () {
        return !!window.Cookie.read(CookieNames.IS_REGISTERED);
    };

    const isExclusiveGame = function (gameId) {
        return exclusiveGameList.indexOf(gameId) > -1;
    };

    const setNgHsTrigger = function () {
        window.ng_hs.onBalanceUpdated(function () {
            document.dispatchEvent(new Event('fw_balanceUpdated'));
            setVipLevelCookie();
        });

        window.ng_hs.showPlayerPopupBanner(function () {
            document.dispatchEvent(new Event('fw_playerPopupBanner'));
        });

        window.ng_hs.registrationSucceeded(function () {
            document.dispatchEvent(new Event('fw_registrationSucceeded'));
        });

        window.ng_hs.depositSucceeded(function () {
            document.dispatchEvent(new Event('fw_depositSucceeded'));
        });

        window.ng_hs.depositAborted(function () {
            document.dispatchEvent(new Event('fw_depositAborted'));
        });

        window.ng_hs.openPage(function (key, customInfo) {
            if (OpenPageFunc) {
                OpenPageFunc(key, customInfo);
            } else {
                ngOpenPage(key, customInfo);
            }
        });

        window.ng_hs.onShowChat(function () {
            document.dispatchEvent(new Event('fw_showChat'));
            AsgFW.showChat();
        });

        window.ng_hs.clearURLParams(function () {
            let query = window.location.search;
            query = removeParameter(query, 'neodl', 'loginIdin');
            query = removeParameter(query, 'neodl', 'rgIdin');
            query = removeParameter(query, 'idin');
            query = removeParameter(query, 'ec');
            query = removeParameter(query, 'referenceId');

            window.history.pushState(null, false, query);
        });

        window.ng_hs.onShowContactUs(function () {
            AsgFW.showContactUs();
        });

        setBingoEvents();
    };

    const ngOpenPage = function (key, customInfo) {
        let params = `?popup=1&LNG=${window.getFrameworkPreferences().Language}`;
        let url;
        url = `https://info.${BrandDomain}/`;
        let newWindow = true;
        switch (key) {
        case 'Play':
            url = '#';
            // eslint-disable-next-line no-unused-vars
            newWindow = false;
            params = false;
            break;
        case 'ResponsibleGaming':
            url += 'responsible.aspx';
            break;
        case 'FAQ':
            if (customInfo === 'UploadDocuments') {
                url = '/HelpAu10tixUploadDocuments.aspx';
            } else {
                url = '/faq.aspx';
            }
            break;
        case 'Bonuses':
        case 'RewardPoints':
            url += 'faq.aspx';
            break;
        case 'HelpDeposit':
            switch (customInfo) {
            case 'bycredit':
                url += `${key}creditcard.aspx`;
                break;
            default:
                url += `${key + customInfo.replace('-', '')}.aspx`;
            }
            break;
        default:
            url += `${key}.aspx`;
        }
        if (params) {
            url += params;
        }
        const win = window.open(url, '_blank');
        win.focus();
    };

    function setGamesObjects(games) {
        allGames = games;
        allGames.forEach((gameItem, i) => {
            try {
                const game = gameItem;
                game.images.webp = getWebpImagePath(game.images.default);
                const gameName = game.name.toLowerCase().trim().replace(/'/g, '');
                game.externalGameProvider = game.externalGameProvider === 'Neogames' ? 'Aspire Global' : game.externalGameProvider;
                allGamesByName[gameName] = game;
                allGamesById[game.id] = game;
            } catch {
                console.error('Game processing error. The game was skipped: ', allGames[i]);
            }
        });
    }

    const getWebpImagePath = function (originalPath) {
        return originalPath
            .replace('Game_Thumb', 'Game_Thumb_webp')
            .replace('.jpg', '.webp');
    };

    const setOnGamesListUpdated = function (fnc) {
        window.ng_hs.onGamesListUpdated(
            function (data) {
                gamesList.storage = data;
                // eslint-disable-next-line no-param-reassign
                data.categories.mainCategories = getCategories();
                // eslint-disable-next-line no-param-reassign
                data.games = getGamesList();
                Tools.track('gamesListUpdated');
                Tools.log('Games updated', data);
                setGamesObjects(gamesList.data.games.instant);
                fnc(data);
            },
        );
        window.ng_fw.updateGamesList();
    };

    const setCmsGamesList = (gamesArray, gamesById, gamesByName) => {
        gamesList.storage = {
            games: {
                instant: gamesArray,
            },
            categories: {
                defaultMainCategoryIndex: 0,
                mainCategories: [],
            },
        };

        allGames = gamesArray;
        allGamesById = gamesById;
        allGamesByName = gamesByName;

        Tools.track('gamesListUpdated');
        Tools.log('Games updated', gamesArray);
    };

    const setLoadGameStart = function (fnc) {
        // wrap passed callback and call it for all cases except Bingo
        window.ng_hs.instantGame.gameLoadStart((gid, mode) => {
            const game = AsgFW.getGameById(gid);
            if (game.gameVerticalId === GameVerticalCodeToIdEnum.BINGO) {
                return;
            }

            fnc(gid, mode);
        });
    };

    const setLoadGameClosed = function (fnc) {
        window.ng_hs.instantGame.gameClosed(fnc);
    };

    const setOnSessionStatusUpdate = function (fnc) {
        window.ng_hs.onSessionStatusUpdate(function (sessionData) {
            Tools.log(`Player's session updated - ${sessionData.Status}`, sessionData);
            updateSessionCookies();
            emitSessionEvents();
            setSegmentedBannersHandlers();
            updateDatadogSessionDetails();
            setBannersEvents();
            fnc(sessionData);
        });
    };

    const emitSessionEvents = () => {
        const playerStateEvent = isLoggedIn() ? 'fw_LoggedIn' : 'fw_LoggedOut';
        document.dispatchEvent(new Event(playerStateEvent));
        if (hasCountryRegulationChanged()) {
            Tools.log('Country or Regulation has changed', { lastCountryCode, lastRegulation, newSession: getSessionDetails() });
            document.dispatchEvent(new Event('countryRegulationChanged'));
        }
    };

    const updateSessionCookies = () => {
        updateCookiePlayerStatus();
        updateCookiePlayerCountryCode();
        updateCookiePlayerRegulationType();
        updateCookiePlayerCurrencyCode();
        updateCountryRegulationCookie();
        updateCookieIsRegistered();
        setVipLevelCookie();
    };

    const updateCookiePlayerStatus = function () {
        const playerID = isLoggedIn() ? getPlayerID() : null;
        const expires = isLoggedIn() ? { minutes: cookiesSessionExpirationTime } : { minutes: 0 };
        Cookie.create(CookieNames.PLAYER_NG_STATUS, playerID, expires, '/');
    };

    const updateCookiePlayerRegulationType = function () {
        // Set last appeared site regulation.
        lastRegulation = Cookie.read(CookieNames.PLAYER_REGULATION_TYPE)
            || getDetectedRegulation();

        // Put to cookie only postlogin playerRegulationType value.
        const regulationType = isLoggedIn()
            ? AsgFW.ngRegulationToAsg(AsgFW.getPlayerRegulationType())
            : null;
        const expires = isLoggedIn() ? { minutes: cookiesSessionExpirationTime } : { minutes: 0 };
        Cookie.create(CookieNames.PLAYER_REGULATION_TYPE, regulationType, expires, '/');
    };

    const updateCookiePlayerCountryCode = function () {
        // Set last countryCode: postlogin player CountryCode or prelogin detected ISO country.
        lastCountryCode = Cookie.read(CookieNames.PLAYER_COUNTRY_CODE)
            || (AsgFW.getDetectedIsoCountry() || '').toUpperCase() || null;

        // Put to cookie only postlogin countryCode value.
        const countryCode = isLoggedIn() ? AsgFW.getPlayerCountryCode() : null;
        const expires = isLoggedIn() ? { minutes: cookiesSessionExpirationTime } : { minutes: 0 };
        Cookie.create(CookieNames.PLAYER_COUNTRY_CODE, countryCode, expires, '/');
    };

    const updateCookiePlayerCurrencyCode = function () {
        // Put to cookie only postlogin playerCurrencyCode value.
        const currencyCode = isLoggedIn() ? AsgFW.getDisplayBalance().Currency : null;
        const expires = isLoggedIn() ? { minutes: cookiesSessionExpirationTime } : { minutes: 0 };
        Cookie.create(CookieNames.PLAYER_CURRENCY_CODE, currencyCode, expires, '/');
    };

    const updateCountryRegulationCookie = () => {
        if (!getRbcSettings('countryRegulationCookieEnabled')
            || Tools.isDeviceEmulatorMode()) {
            removeCountryRegulationCookie();
            return;
        }

        const country = AsgFW.getCurrentCountry();
        const regulation = AsgFW.getRegulation();
        const platformId = AsgFW.getPlatformId();
        const playerIsLoggedIn = Cookie.read(CookieNames.PLAYER_NG_STATUS);
        const playerState = (playerIsLoggedIn || AsgFW.isLoggedIn()) ? 1 : 0;
        const isNativeApp = Tools.isNativeApp() ? 1 : 0;
        const isNativeSsoApp = Tools.isNativeSsoApp() ? 1 : 0;

        const countryRegulation = (`${country}:${regulation}:${platformId}:${pamPlatform}:${isNativeApp}:${isNativeSsoApp}:${playerState}`).toUpperCase();
        const expires = { minutes: 60 };
        Cookie.create(CookieNames.COUNTRY_REGULATION, countryRegulation, expires, '/');
    };

    const removeCountryRegulationCookie = () => {
        Cookie.create(CookieNames.COUNTRY_REGULATION, null, -1, '/');
    };

    /**
     * Add orientation change event listener to remove countryRegulation cookie
     * for the device emulator mode in the browser to avoid caching issues.
     */
    if (typeof screen.orientation !== 'undefined') {
        screen.orientation.addEventListener('change', () => {
            if (Tools.isDeviceEmulatorMode()) {
                removeCountryRegulationCookie();
            }
        });
    }

    const updateCookieIsRegistered = () => {
        if (isLoggedIn()) {
            Cookie.create(CookieNames.IS_REGISTERED, '1', '180');
        }
    };

    /**
     *  Save player vip level inside cookie
     */
    const setVipLevelCookie = function () {
        const l = getPlayerVipLevel(); // get player VIP level from NG session

        // if player logged out or
        if (!l) {
            return;
        }
        Cookie.create(CookieNames.VIP_LEVEL, l, '30'); // set cookie Vip Level | save cookie for 30 day
    };

    const hasCountryRegulationChanged = function () {
        return lastCountryCode !== getCurrentCountry().toUpperCase()
            || lastRegulation !== getRegulation();
    };

    const getCategories = function () {
        const { categories } = gamesList.data;
        if (isActiveAppealingToChildrenFilter()) {
            const filteredCategories = filterNotPresentGames(
                // make a copy of object due to potential modifications by filterNotPresentGames()
                JSON.parse(JSON.stringify(categories)),
            );
            return filteredCategories.mainCategories;
        }
        return categories.mainCategories;
    };

    /**
     Temporary solution - until all download server will be migrated to Azure.
     TODO: remove the function after NG will update URLs on their side
     * options:
     *   - 'imageOrientation':'v' will return vertical game image
     * @param options
     */
    const getGamesList = function (options) {
        const games = JSON.parse(JSON.stringify(gamesList.data.games));

        if (isHideNetentGames()) {
            games.instant = games.instant.filter(
                function (game) {
                    return game.externalGameProvider !== 'NetEnt';
                },
            );
        }

        if (isActiveAppealingToChildrenFilter()) {
            games.instant = games.instant.filter(
                function (game) {
                    return notPresentGamesData.GameListId.indexOf(game.id.toString()) < 0;
                },
            );
        }

        // options 'imageOrientation':'h'
        if (options && options.imageOrientation && options.imageOrientation === 'v') {
            games.instant.forEach(function (game) {
                // eslint-disable-next-line no-param-reassign
                game.images.default = game.images.default.replace('_1x_', '_3x_');
            });
        }

        // Replace all media until NG will not do it by themselves.
        const dsEnv = getDsEnv();
        const cdnUrl = getCdnHost()
            ? `https://${getCdnHost()}`
            : `https://cdn.${dsEnv.prefixASG}aspireglobal.com`;
        if (dsEnv.location === 'ASG') {
            games.instant.forEach(function (game) {
                if (game.backgroundImageUrl.indexOf('gamesrv1') !== -1) {
                    // eslint-disable-next-line no-param-reassign
                    game.backgroundImageUrl = game.backgroundImageUrl.replace(`https://download.${dsEnv.prefixNG}gamesrv1.com`, cdnUrl);
                    // eslint-disable-next-line no-param-reassign
                    game.images.default = game.images.default.replace(`https://download.${dsEnv.prefixNG}gamesrv1.com`, cdnUrl);
                }
            });
            return games;
        }
        return games;
    };

    /**
     * Returns Game object from Games storage by game ID.
     * @param Number gid Game ID
     * @returns Object | undefined.
     */
    const getGameById = function (gid) {
        if (allGames.length < 1) {
            setGamesObjects(gamesList.data.games.instant);
        }

        return allGamesById[gid];
    };

    const getGameByName = function (name) {
        const key = name?.toLowerCase().replaceAll("'", '') || '';

        if (allGames.length < 1) {
            setGamesObjects(gamesList.data.games.instant);
        }

        return allGamesByName[key];
    };

    const setGetWinnersData = (callback) => {
        const winners = [];
        const props = ['playerName', 'winAmount', 'currencySymbol', 'gameName',
            'betDateTime', 'countryCode', false, 'currencyAlignment'];

        fetch(getWinnerTickerUrl())
            .then(response => response.text())
            .then(data => {
                // eslint-disable-next-line no-param-reassign
                data = data.replace('&LW=', '');
                // Break if the games list is empty.
                if (data.length === 0) {
                    return;
                }

                // Create winners array
                const winnersArr = data.split('^');
                const isFilterAppealingToChildren = isActiveAppealingToChildrenFilter();
                winnersArr.forEach(function (item) {
                    const winner = item.split(',');
                    const obj = {};
                    props.forEach(function (property, relatedIndex) {
                        if (property) {
                            obj[property] = winner[relatedIndex];
                        }
                    });
                    obj.game = getGameByName(obj.gameName);
                    const curGameId = (obj.game !== undefined) ? obj.game.id.toString() : null;

                    if (isFilterAppealingToChildren
                        && notPresentGamesData
                        && Array.isArray(notPresentGamesData.GameListId)
                        && notPresentGamesData.GameListId.includes(curGameId)
                    ) {
                        return;
                    }

                    winners.push(obj);
                });
                callback(winners);
            });
    };

    const getWinnerTickerUrl = function () {
        const countryCodeQuery = `CountryCode=${getCurrentCountry()}`;
        let pathAndQuery = `/Ticker.aspx?${countryCodeQuery}`;
        if (isShowOnlyWinnersOfThisBrand) {
            pathAndQuery += `&CSI=${getBrandID()}`;
        }
        let tickerUrl = 'https://externalservices.gameserver1-mt.com';

        // Return URL from NeoCMS if integration enable and URL exists.
        if (isNeoCmsIntegrationEnabled()) {
            const pamUrl = getPamUrls(PamInstanceUrlTypesEnum.PAM_EXTERNALSERVICES);
            if (pamUrl) {
                tickerUrl = UrlService.trimSlashes(pamUrl);
            }
        }

        return tickerUrl + pathAndQuery;
    };

    const getNotPresentGamesData = function () {
        const brand = isBrandDK() ? 'dk' : '';
        fetch(`${AsgFW.getFrameworkUri()}data/general-data/notPresentGamesSetting${brand}.json`)
            .then(response => response.json())
            .then(response => {
                notPresentGamesData = response;
            })
            .catch(e => {
                Tools.error('Failed to get not present games data', e);
            });
    };

    const filterNotPresentGames = function (categories) {
        // eslint-disable-next-line no-plusplus
        for (let mainImdex = 0; mainImdex < categories.mainCategories.length; mainImdex++) {
            // eslint-disable-next-line max-len,no-plusplus
            for (let categoriesIndex = 0; categoriesIndex < categories.mainCategories[mainImdex].subCategories.length; categoriesIndex++) {
                // eslint-disable-next-line max-len,no-plusplus
                for (let gameIndex = 0; gameIndex < categories.mainCategories[mainImdex].subCategories[categoriesIndex].instantGamesOrder.length; gameIndex++) {
                    // eslint-disable-next-line max-len
                    if (Tools.ifKeyExists(categories.mainCategories[mainImdex].subCategories[categoriesIndex].instantGamesOrder[gameIndex].toString(), notPresentGamesData.GameListId)) {
                        // eslint-disable-next-line max-len
                        categories.mainCategories[mainImdex].subCategories[categoriesIndex].instantGamesOrder.splice(gameIndex, 1);
                        // eslint-disable-next-line no-plusplus
                        gameIndex--;
                    }
                }
            }
        }
        return categories;
    };

    const isPresentPageGames = function (gid) {
        return notPresentGamesData.GameListId
            && (notPresentGamesData.GameListId.indexOf(gid.toString()) > -1);
    };

    const getNotPresentGamesList = function () {
        return notPresentGamesData;
    };

    const isBrandDK = function () {
        return getDomainSuffixes() === 'dk' || getRegulation() === 'DK';
    };

    const isBrandGb = function () {
        return isUkCountry() || getRegulation() === 'GB';
    };

    /**
     * Detects whether current player's regulation is UK regulation.
     * @returns {boolean}
     */
    const isUkRegulation = function () {
        if (isLoggedIn()) {
            return getSessionDetails().CountryCode === 'GB';
        }
        return isUkCountry();
    };

    const isUkCountry = function () {
        return country === 'uk';
    };

    const isDEcountry = function () {
        return getCurrentCountry() === 'de';
    };

    /**
     * Validates if TLD (domain suffix) is 'de'.
     * Applicable for German local sites.
     * @returns {boolean}
     */
    const isDEregion = function () {
        return getDomainSuffixes() === 'de';
    };

    /**
     * Detects whether current player's regulation is Germany regulation.
     * @returns {boolean}
     */
    const isDEregulation = function () {
        return getRegulation() === 'DE' || isDEcountry();
    };

    const getDomainSuffixes = function () {
        return getBrandDomain().split('.').pop();
    };

    const getLastAction = function () {
        return lastAction;
    };

    const removeParameter = function (query, key, val) {
        let localQuery = query;
        if (val !== undefined) {
            localQuery = query.replace(`${key}=${val}&`, '').replace(`${key}=${val}`, '');
        } else {
            const paramKeyIndex = localQuery.indexOf(`${key}=`);
            if (paramKeyIndex !== -1) {
                let param;
                if (localQuery.substr(paramKeyIndex).indexOf('&') !== -1) {
                    param = localQuery.substr(paramKeyIndex, localQuery.substr(paramKeyIndex).indexOf('&') + 1);
                } else {
                    param = localQuery.substr(paramKeyIndex);
                }
                localQuery = localQuery.replace(param, '');
            }
        }
        return localQuery;
    };

    /**
     * @deprecated
     * TODO: Toremove after announcement.
     * get Azure API Url, form mrplay change prefix from dev to uat
     * @returns {string}
     */
    const getAzureAPIUrl = function () {
        const list = ['mrplay.com'];
        let envPrefix = Tools.getEnvPrefix();
        if (envPrefix === 'dev.' && list.includes(BrandDomain.trim().toLowerCase())) {
            envPrefix = 'uat.';
        }
        return `https://fnc.${envPrefix}aspireglobal.com/services/azureapi/`;
    };

    /**
     * Send a new GameVerticalID to PAM.
     * @param GameVerticalID from PAM.
     * @return void
     */
    const setDefaultGameVerticalID = function (GameVerticalID) {
        window.ng_fw.setDefaultGameVerticalID(GameVerticalID);
        Tools.log('PAM Game Vertical ID set to: ', GameVerticalID);
    };

    /**
     * Returns geolocation information by ip from SolarAPI.
     * @param ip
     * @returns {*}
     */
    const getCountry = function (ip) {
        return SolarAPI.get('/api/v2/brands/{casinoId}/geolocation/', { ip }, function (response) {
            return response;
        });
    };

    /**
     * Returns current detected country or player registration country.
     * @returns string
     */
    const getCurrentCountry = () => {
        let countryCode = getDetectedIsoCountry();
        const cookieCountry = Cookie.read(CookieNames.PLAYER_COUNTRY_CODE);
        const playerIsLoggedIn = Cookie.read(CookieNames.PLAYER_NG_STATUS);
        if (isLoggedIn()) {
            countryCode = getPlayerCountryCode();
        } else if (playerIsLoggedIn && cookieCountry) {
            countryCode = cookieCountry;
        }
        return countryCode.toLowerCase();
    };

    /**
     * Return full country name
     */
    const getCountryName = function () {
        return countryName;
    };

    /**
     * Html markUp for contact us widget for all brands
     * @type {string}
     */
    const asgContactUsStyleMarkUp = `.asg--contact-us-modal{
            background: rgba(0, 0, 0, 0.8);
            height: 100%;
            position: fixed;
            width: 100%;
            left: 0;
            top: 0;
            z-index: 3000;
            display: none;
        }
        .asg--contact-us-wrap{
            position: absolute;
            max-width: 740px;
            left: 0;
            right: 0;
            margin: auto;
            height: 420px;
            top: calc(50% - 200px);
            display: flex;
            -webkit-box-shadow: 5px -5px 10px 0px rgba(0,0,0,0.75);
            -moz-box-shadow: 5px -5px 10px 0px rgba(0,0,0,0.75);
            box-shadow: 5px -5px 10px 0px rgba(0,0,0,0.75);
        }
        .asg--contact-us-left{
            text-align: center;
            flex: 2;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        .asg--contact-us-brand-text{
            padding: 8%;
            color: #ededed;
        }
        .asg--contact-us-title{
            font-size: 29px;
            font-weight: 700;
            margin-bottom: 10%;
            color: #65676d;
            padding: 0px 30px;
            line-height: 30px;
            text-transform: uppercase;
        }
        .asg--contact-us-right{
            text-align: center;
            flex: 3;
            display: flex;
        }
        .asg--contact-us-right-wrap{
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        .asg--contact-us-icon{
            max-width: 120px;
            height: auto;
        }
        .asg--contact-us-close{
            cursor: pointer;
            width: 14px;
            position: absolute;
            top: 9px;
            right: 9px;
        }
        #asg--contact-us-close-svg{
            width: 100%;
            height: auto;
        }
        .asg--contact-us-btn{
            padding: 10px 20px;
            width: 220px;
            margin: 0 auto;
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
        }
        .asg--contact-us-email-btn{
            background-color: #65676d;
            margin-top: 20px;
            margin-bottom: 10%;
        }
        .asg--support-time{
            padding: 0 20px 15px 50px;
            font-size: 13px;
            color: #373737;
            text-align: left;
        }
        .asg--btn-svg{
            width: 20px;
            height: auto;
            margin-right: 7px;
            margin-bottom: -1px;
        }
        .asg--contact-us-btn,
        .asg--contact-us-btn:hover,
        .asg--contact-us-btn:focus{
            text-decoration: none;
        }
        .asg--contact-us-btn:hover,
        .asg--contact-us-close:hover{
            opacity: 0.9;
        }
        .asg--contact-us-btn.hide{
            display:none;
        }
        .asg--upload-file{
            padding: 5px 30px 15px 50px;
            text-align: left;
            color: #373737;
            font-size: 13px;
        }
        .asg--upload-file-text{
            display: block;
            text-align: left;
        }
        @media screen and (max-width: 768px) {
            .asg--contact-us-left, 
            .asg--contact-us-right{
                display: block;
            }
            .asg--contact-us-wrap {
                flex-direction: column;
            }
            .asg--contact-us-icon-wrap {
                margin-top: 35px;
            }
            .asg--contact-us-brand-text {
                padding: 5%;
            }
            .asg--contact-us-wrap {
                bottom: 0;
                top: 0;
                margin: 7%;
                overflow: scroll;
                height: auto;
            }
            .asg--contact-us-title {
                display: none;
            }
            .asg--contact-us-live-chat-btn {
                margin-top: 10%;
            }
        }`;

    const asgContactUsNodeMarkUp = `<div class="asg--contact-us-wrap">
            <div class="asg--contact-us-left">
                <div class="asg--contact-us-icon-wrap">
                    <img class="asg--contact-us-icon" src="data:image/png;base64,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"/>
                </div>
                <div class="asg--contact-us-brand-text"></div>
            </div>
            <div class="asg--contact-us-right">
                <div class="asg--contact-us-right-wrap">
                    <div class="asg--contact-us-close">
                        <svg id="asg--contact-us-close-svg" data-name="Isolation Mode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 87.14 87.14"><defs><style>.cls-10{fill:#65676d;}</style></defs><polygon class="cls-10" points="87.14 7.09 80.05 0 43.57 36.48 7.09 0 0 7.09 36.48 43.57 0 80.05 7.09 87.14 43.57 50.66 80.05 87.14 87.14 80.05 50.66 43.57 87.14 7.09"/></svg>
                    </div>
                    <div class="asg--contact-us-title"></div>
                    <span onclick="AsgFW.showChat()" class="asg--contact-us-live-chat-btn asg--contact-us-btn" data-action="showChat">
                            <span class="asg--contact-us-live-chat-icon">
                                <svg  class="asg--btn-svg"  data-name="Isolation Mode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128.31 101.46"><defs><style>.cls-1{fill:#ededed;}</style></defs><path class="cls-1" d="M118.62,1.42H55.2A11.12,11.12,0,0,0,44.1,12.53v3.89H13.6A12.23,12.23,0,0,0,1.38,28.64v40A12.23,12.23,0,0,0,13.6,80.86H25.86v19a3,3,0,0,0,1.87,2.78,3.2,3.2,0,0,0,1.13.22A3,3,0,0,0,31,102l20.4-21.11H69.71c8.71,0,12.81-3.42,14.67-7.27L99.71,89.17a3,3,0,0,0,2.14.9,3.05,3.05,0,0,0,1.14-.23,3,3,0,0,0,1.86-2.77V67.71h13.77a11.08,11.08,0,0,0,11.07-11.07V12.49A11.08,11.08,0,0,0,118.62,1.42ZM69.71,74.86H50.15a3,3,0,0,0-2.16.91L31.86,92.47V77.86a3,3,0,0,0-3-3H13.6a6.23,6.23,0,0,1-6.22-6.22v-40a6.23,6.23,0,0,1,6.22-6.22H44.1V56.6A11.12,11.12,0,0,0,55.2,67.71H78.59l1.07,1.08C79.17,72,77.09,74.86,69.71,74.86Zm54-18.22a5.08,5.08,0,0,1-5.07,5.07H101.85a3,3,0,0,0-3,3v15L82,62.6a3,3,0,0,0-2.14-.89H55.2a5.11,5.11,0,0,1-5.1-5.11V22.42h.06v-6H50.1V12.53a5.11,5.11,0,0,1,5.1-5.11h63.42a5.08,5.08,0,0,1,5.07,5.07Z" transform="translate(-1.38 -1.42)"/><path class="cls-1" d="M108.62,23.16h-43a3,3,0,0,0,0,6h43a3,3,0,0,0,0-6Z" transform="translate(-1.38 -1.42)"/><path class="cls-1" d="M78.62,40.16h-13a3,3,0,0,0,0,6h13a3,3,0,0,0,0-6Z" transform="translate(-1.38 -1.42)"/></svg>
                            </span> <span class="asg--live-chat-text"></span> </span>
                    <a href="/contact-us/" class="asg--contact-us-email-btn asg--contact-us-btn">
                        <span class="asg--contact-us-email-icon">
                            <svg  class="asg--btn-svg" data-name="Isolation Mode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 125.53 88.77"><defs><style>.cls-1{fill:#ededed;}</style></defs><path class="cls-1" d="M120.12,7.77H11A8.2,8.2,0,0,0,2.77,16V88.35A8.21,8.21,0,0,0,11,96.54H120.12a8.21,8.21,0,0,0,8.19-8.19V16A8.2,8.2,0,0,0,120.12,7.77Zm-2.91,6.34L66.91,64a2,2,0,0,1-2.74,0L13.87,14.11Zm-108.1,71V18.32L41,49.88ZM13,90.2,45.47,54.35,59.7,68.45a8.32,8.32,0,0,0,11.67,0l14-13.88L118,90.2Zm109-5.07-32.07-35L122,18.32Z" transform="translate(-2.77 -7.77)"/></svg>
                        </span> <span class="asg--email-text"></span></a>
                    <div class="asg--support-time"></div>
                    <div class="asg--upload-file">
                        <span class="asg--upload-file-text"></span>
                    </div>
                </div>
            </div>
        </div>`;

    /**
     * get default params from Dictionary
     * @returns {{titleTextColor: string, documentUploaderText: *, brandText: *,
     * chatBgColor: string, mainPanelTextColor: string, businessHoursText: *,
     * subPanelBgColor: string, title: *, mainPanelBgColor: string,
     * liveChatButtonText: *, chatBtnTextColor: string, emailButtonText: *,
     * subPanelTextColor: string, iconUrl: string, emailBtnTextColor: string,
     * emailBgColor: string}}
     */
    const getParameterFromDictionary = function () {
        return {
            iconUrl: '',
            title: Dictionary.translate('title'),
            brandText: Dictionary.translate('brandText'),
            liveChatButtonText: Dictionary.translate('liveChatButtonText'),
            emailButtonText: Dictionary.translate('emailButtonText'),
            businessHoursText: Dictionary.translate('businessHoursText'),
            subPanelBgColor: Dictionary.translate('subPanelBgColor') === 'subPanelBgColor' ? '#373737' : Dictionary.translate('subPanelBgColor'),
            mainPanelBgColor: Dictionary.translate('mainPanelBgColor') === 'mainPanelBgColor' ? '#ededed' : Dictionary.translate('mainPanelBgColor'),
            chatBgColor: Dictionary.translate('chatBgColor') === 'chatBgColor' ? '#373737' : Dictionary.translate('chatBgColor'),
            emailBgColor: Dictionary.translate('emailBgColor') === 'emailBgColor' ? '#65676d' : Dictionary.translate('emailBgColor'),
            chatBtnTextColor: Dictionary.translate('chatBtnTextColor') === 'chatBtnTextColor' ? '#ededed' : Dictionary.translate('chatBtnTextColor'),
            emailBtnTextColor: Dictionary.translate('emailBtnTextColor') === 'emailBtnTextColor' ? '#ededed' : Dictionary.translate('emailBtnTextColor'),
            subPanelTextColor: Dictionary.translate('subPanelTextColor') === 'subPanelTextColor' ? '#ededed' : Dictionary.translate('subPanelTextColor'),
            mainPanelTextColor: Dictionary.translate('mainPanelTextColor') === 'mainPanelTextColor' ? '#373737' : Dictionary.translate('mainPanelTextColor'),
            titleTextColor: Dictionary.translate('titleTextColor') === 'titleTextColor' ? '#65676d' : Dictionary.translate('titleTextColor'),
            documentUploaderText: Dictionary.translate('documentUploader'),
        };
    };

    /**
     * replace text and color by options
     * have default value from (Dictionary)
     * @param options
     */
    const showAsgContactUs = function (options) {
        const defaultValue = getParameterFromDictionary();
        const settings = {
            iconUrl: Object.prototype.hasOwnProperty.call(options, 'iconUrl') ? options.iconUrl : defaultValue.iconUrl,
            title: Object.prototype.hasOwnProperty.call(options, 'title') ? options.title : defaultValue.title,
            brandText: Object.prototype.hasOwnProperty.call(options, 'brandText') ? options.brandText : defaultValue.brandText,
            liveChatButtonText: Object.prototype.hasOwnProperty.call(options, 'liveChatButtonText') ? options.liveChatButtonText : defaultValue.liveChatButtonText,
            emailButtonText: Object.prototype.hasOwnProperty.call(options, 'emailButtonText') ? options.emailButtonText : defaultValue.emailButtonText,
            businessHoursText: Object.prototype.hasOwnProperty.call(options, 'businessHoursText') ? options.businessHoursText : defaultValue.businessHoursText,
            subPanelBgColor: Object.prototype.hasOwnProperty.call(options, 'sub_panel_bg_color') ? options.sub_panel_bg_color : defaultValue.subPanelBgColor,
            mainPanelBgColor: Object.prototype.hasOwnProperty.call(options, 'main_panel_bg_color') ? options.main_panel_bg_color : defaultValue.mainPanelBgColor,
            chatBgColor: Object.prototype.hasOwnProperty.call(options, 'chat_bg_color') ? options.chat_bg_color : defaultValue.chatBgColor,
            emailBgColor: Object.prototype.hasOwnProperty.call(options, 'email_btn_text_color') ? options.email_btn_text_color : defaultValue.emailBgColor,
            chatBtnTextColor: Object.prototype.hasOwnProperty.call(options, 'chat_btn_text_color') ? options.chat_btn_text_color : defaultValue.chatBtnTextColor,
            emailBtnTextColor: Object.prototype.hasOwnProperty.call(options, 'email_btn_text_color') ? options.email_btn_text_color : defaultValue.emailBtnTextColor,
            mainPanelTextColor: Object.prototype.hasOwnProperty.call(options, 'main_panel_text_color') ? options.main_panel_text_color : defaultValue.mainPanelTextColor,
            subPanelTextColor: Object.prototype.hasOwnProperty.call(options, 'sub_panel_text_color') ? options.sub_panel_text_color : defaultValue.subPanelTextColor,
            titleTextColor: Object.prototype.hasOwnProperty.call(options, 'title_text_color') ? options.title_text_color : defaultValue.titleTextColor,
            documentUploaderText: Object.prototype.hasOwnProperty.call(options, 'documentUploaderText') ? options.documentUploaderText : defaultValue.documentUploaderText,
            ...options,
        };

        const brandName = getBrandName();
        const body = document.querySelector('body');

        const asgContactUsStyleElement = document.createElement('style');
        asgContactUsStyleElement.innerHTML = asgContactUsStyleMarkUp;
        const asgContactUs = document.createElement('div');
        asgContactUs.innerHTML = asgContactUsNodeMarkUp;
        asgContactUs.className = 'asg--contact-us-modal';

        body.append(asgContactUsStyleElement);
        body.append(asgContactUs);
        if (settings.iconUrl !== '') {
            body.querySelector('.asg--contact-us-icon').setAttribute('src', settings.iconUrl);
        }

        const chatRequiresLogin = AsgFW.chatRequiresLogin();

        /**
         * find and change contact-us popup text and color
         */
        asgContactUs.querySelector('.asg--contact-us-brand-text').innerHTML = settings.brandText.replace('[BRAND NAME]', brandName);
        asgContactUs.querySelector('.asg--contact-us-title').innerHTML = settings.title.replace('[BRAND NAME]', brandName);
        asgContactUs.querySelector('.asg--live-chat-text').innerHTML = settings.liveChatButtonText;
        asgContactUs.querySelector('.asg--email-text').innerHTML = settings.emailButtonText;
        asgContactUs.querySelector('.asg--support-time').innerHTML = settings.businessHoursText.replace('[BRAND NAME]', brandName);
        asgContactUs.querySelector('.asg--upload-file-text').innerHTML = settings.documentUploaderText;
        asgContactUs.querySelector('.asg--contact-us-live-chat-btn').style.backgroundColor = settings.chatBgColor;
        asgContactUs.querySelector('.asg--contact-us-email-btn').style.backgroundColor = settings.emailBgColor;
        asgContactUs.querySelector('.asg--contact-us-left').style.backgroundColor = settings.subPanelBgColor;
        asgContactUs.querySelector('.asg--contact-us-right').style.backgroundColor = settings.mainPanelBgColor;
        asgContactUs.querySelector('.asg--contact-us-title').style.color = settings.titleTextColor;
        asgContactUs.querySelector('.asg--support-time').style.color = settings.mainPanelTextColor;
        asgContactUs.querySelector('.asg--upload-file-text').style.color = settings.mainPanelTextColor;
        asgContactUs.querySelector('.asg--contact-us-brand-text').style.color = settings.subPanelTextColor;
        asgContactUs.querySelector('.asg--live-chat-text').style.color = settings.chatBtnTextColor;
        asgContactUs.querySelector('.asg--email-text').style.color = settings.emailBtnTextColor;
        if (!isLoggedIn() && chatRequiresLogin) {
            asgContactUs.querySelector('.asg--contact-us-live-chat-btn').classList.add('hide');
        }
        setTimeout(() => {
            body.querySelector('.asg--contact-us-modal').style.display = 'block';
            document.body.classList.add('asg--contact-us-modal-activated');
        }, 50);

        /**
         * set click methods for popup buttons
         */
        asgContactUs.querySelector('.asg--contact-us-close').addEventListener('click', () => {
            body.removeChild(asgContactUs);
            removeClassFromBody('asg--contact-us-modal-activated');
        });
        asgContactUs.querySelector('.asg--contact-us-btn').addEventListener('click', () => {
            body.removeChild(asgContactUs);
            removeClassFromBody('asg--contact-us-modal-activated');
        });
        asgContactUs.querySelector('#document-uploader').addEventListener('click', () => {
            body.removeChild(asgContactUs);
            removeClassFromBody('asg--contact-us-modal-activated');
        });
    };

    /**
     * remove class from body
     * @param cls
     */
    const removeClassFromBody = (cls) => {
        document.body.classList.remove(cls);
    };

    /**
     * get HideLoyaltyPageFlag from brandInit
     */
    const isHideLoyaltyPageFlag = () => (getRbcSettings('hideLoyaltyPageFlag'));

    /**
     * check if hide netent games
     */
    const isHideNetentGames = () => {
        const brandData = getBrandInit();

        const isHideNetent = brandData
        && Object.prototype.hasOwnProperty.call(brandData.data.RBCSettings, 'oldNetEntHide')
            ? brandData.data.RBCSettings.oldNetEntHide : hideNetentFlag;

        const noNetentGamesCountries = ['uk'];
        let playerCountry = getCurrentCountry();
        switch (playerCountry) {
        case 'gb':
            playerCountry = 'uk';
            break;
        default:
        }
        return isHideNetent && noNetentGamesCountries.includes(playerCountry);
    };

    /**
     * Grab brand info
     */
    const getBrandInit = function () {
        return brandInitData;
    };

    /**
     * Set brand info
     * @param {*} data
     */
    const setBrandInit = function (data) {
        brandInitData = data;
    };

    /**
     * Returns PAM URLs object or requested URL by type.
     * @param urlType
     * @returns {*|{}|string}
     */
    const getPamUrls = function (urlType) {
        const brandData = Object.prototype.hasOwnProperty.call(brandInitData, 'data')
            ? brandInitData.data
            : {};
        const pamUrls = Object.prototype.hasOwnProperty.call(brandData, 'pamUrls')
            ? brandData.pamUrls
            : {};

        if (pamUrls && urlType) {
            return Object.prototype.hasOwnProperty.call(pamUrls, urlType)
                ? pamUrls[urlType]
                : '';
        }

        return pamUrls;
    };

    const getPamUrlInfoPages = () => getPamUrls(PamInstanceUrlTypesEnum.PAM_INFO_PAGES_SERVER);

    /**
     * Returns RBC Settings object or requested setting value
     * @param setting {string}
     * @returns {Object|null|*}
     */
    const getRbcSettings = function (setting) {
        if (rbcSettings && setting) {
            return Object.prototype.hasOwnProperty.call(rbcSettings, setting)
                ? rbcSettings[setting]
                : null;
        }

        return rbcSettings;
    };

    const getDetectedCountry = function () {
        return country;
    };

    const getCurrency = function () {
        return isLoggedIn() ? getDisplayBalance().Currency : currency;
    };

    const getDetectedIsoCountry = function () {
        return isoCountry;
    };

    /**
     * Get the most recent played games by Player.
     * @param successCallback - callback function to be called once games are retrieved.
     * The callback function will get the only argument - an array with game objects like this:
     *    [
     *        {
     *           "gameId": 205,
     *           "gameName": "Starburst"
     *       },
     *        {
     *           "gameId": 563,
     *           "gameName": "Blackjack Doubler"
     *       }
     *    ]
     * @returns Promise with raw data, got from the request to GetTopPlayedGames Platform API.
     */
    // eslint-disable-next-line consistent-return
    const getRecentGames = function (successCallback) {
        if (isLoggedIn()) {
            // Prepare request to Platform API - GetTopPlayedGames
            const urn = '/api/asg/player/GetTopPlayedGames';
            const requestBody = {
                SessionID: getSessionDetails().SessionToken,
                PlayerID: getSessionDetails().PlayerID,
            };
            // Handle successful response.
            const successResponse = function (data) {
                if (successCallback instanceof Function
                    && data.errorMessage === 'OK'
                    && data.TopPlayedGamesItems.length > 0
                ) {
                    const recentGamesOutput = data.TopPlayedGamesItems
                        .filter(function (el) {
                            return el.GameVertical !== 'SportsBetting' && getGameById(el.TopPlayedGameId) !== undefined;
                        })
                        .map(function (el) {
                            return {
                                gameId: el.TopPlayedGameId,
                                gameName: el.TopPlayedGameName,
                            };
                        });
                    successCallback(recentGamesOutput);
                }
            };

            // Make a request and return the Promise object.
            return PlatformAPI.post(urn, requestBody, successResponse);
        }

        console.warn('Recent games could be fetched only for Logged-in Player.');
    };

    /**
     * Refresh balance state and trigger event
     * @return {PromiseLike<*> | Promise<*>}
     */
    const refreshBalance = function () {
        return window.ng_fw.refreshBalance()
            .then((response) => {
                document.dispatchEvent(new Event('fw_balanceUpdated'));
                return response;
            });
    };

    const liveCasinoBetLimitsRequest = function () {
        return new Promise((resolve, reject) => {
            SolarAPI.get(
                '/api/v1/live-casino-betlimits',
                {},
                (betLimitsResponse) => {
                    if (betLimitsResponse
                        && betLimitsResponse.data
                        && betLimitsResponse.data.games
                        && betLimitsResponse.data.games.length > 0
                    ) {
                        const betLimitsFormated = {};
                        betLimitsResponse.data.games.forEach((game) => {
                            if (game.gameSlug) {
                                betLimitsFormated[game.gameSlug] = game;
                            }
                        });
                        resolve(betLimitsFormated);
                    } else {
                        reject(new Error('Get Betlimits response returned unexpected format'));
                    }
                },
                (e) => {
                    console.error('liveCasinoBetLimits request failed', e);
                    reject(e);
                },
            );
        });
    };

    const getLiveCasinoBetLimits = function () {
        if (Object.keys(liveCasinoBetLimits).length > 0) {
            return liveCasinoBetLimits;
        }

        throw new Error('Before accessing bet limits please call AsgFW.liveCasinoBetLimitsRequest()');
    };

    const getLiveCasinoState = function () {
        if (!liveCasinoStatePromise) {
            const successCallback = (stateResponse, resolve, reject) => {
                if (stateResponse && stateResponse.data && stateResponse.data.tables) {
                    const stateFormated = {};
                    stateResponse.data.tables.forEach((game) => {
                        if (game.gameSlug) {
                            stateFormated[game.gameSlug] = game;
                        }
                    });
                    resolve(stateFormated);
                } else {
                    reject(new Error('Get Live casino state response returned unexpected format'));
                }
            };
            const errorCallback = (e, reject) => {
                console.error('getLiveCasinoState request failed', e);
                reject(e);
            };

            liveCasinoStatePromise = new Promise((resolve, reject) => {
                SolarAPI.get(
                    '/api/v1/live-casino-states',
                    {
                        display: isMobilePamPlatform() ? 'on_mobile' : 'on_desktop',
                    },
                    stateResponse => successCallback(stateResponse, resolve, reject),
                    e => errorCallback(e, reject),
                );
            });

            // Reset to allow further updates
            setTimeout(() => {
                liveCasinoStatePromise = null;
            }, 15000); // Uses 15 seconds to be reset before repeated call (each 20 seconds)
        }
        return liveCasinoStatePromise;
    };

    /**
     * Replaces spaces with dashes, trims and puts to lower case passed game name
     * @param gameName
     * @return {string}
     */
    const getGameSlug = function (gameName) {
        return gameName.trim().replace(/[ ]/g, '-').toLowerCase();
    };

    /**
     * Returns currency sign by code. In case sign not defined - retuns code
     * @param currencyCode
     * @return {string}
     */
    const getCurrencySignByCode = function (currencyCode) {
        const codeToSign = {
            EUR: '&euro;',
            AUD: 'A$',
            USD: '$',
            GBP: '&pound;',
            DKK: 'kr',
            NOK: 'kr',
            SEK: 'kr',
            CAD: 'C$',
            BRL: 'R$',
            CLP: '$',
            INR: '&#8377;',
            NZD: 'NZ$',
            PEN: 'S/',
            ZAR: 'R',
            JPY: '&yen;',
        };

        return codeToSign[currencyCode] ? codeToSign[currencyCode] : currencyCode;
    };

    function getPlayerVerificationDetails(fn) {
        window.ng_fw.getPlayerVerificationDetails(fn);
    }

    function showVerificationPopUp() {
        return window.ng_fw.showVerificationPopUp();
    }

    function onVerificationStatusUpdate(fn) {
        return window.ng_hs.onVerificationStatusUpdate(fn);
    }

    /**
     * Calls GET smart-footer Solar API
     * @param host
     * @param countryCode
     * @param reg
     * @return {Promise<unknown>}
     */
    const getSmartFooter = function (host, countryCode = null, reg = null) {
        return new Promise((resolve, reject) => {
            const requestParams = {
                host,
            };

            if (countryCode) {
                requestParams.country = countryCode;
            }

            if (reg) {
                requestParams.reg = reg;
            }

            SolarAPI.get(
                '/api/v1/brands/{casinoId}/smart-footer',
                requestParams,
                (getSmartFooterResponse) => {
                    resolve(getSmartFooterResponse);
                },
                (e) => {
                    console.error('getSmartFooter request failed', e);
                    reject(e);
                },
            );
        });
    };

    const getCopyright = function ({
        language,
        host,
        countryCode = null,
        regulation = null,
        companyName = null,
        companyCountry = null,
        licenseNumber = null,
    }) {
        return new Promise((resolve, reject) => {
            const requestParams = {
                language,
                host,
                casinoId: getBrandID(),
            };

            if (countryCode) {
                requestParams.country = countryCode;
            }

            if (regulation) {
                requestParams.regulation = regulation;
            }

            if (companyName) {
                requestParams.companyName = companyName;
            }

            if (companyCountry) {
                requestParams.companyCountry = companyCountry;
            }

            if (licenseNumber) {
                requestParams.licenseNumber = licenseNumber;
            }

            SolarAPI.get(
                '/api/v1/copyrights',
                requestParams,
                (getCopyrightResponse) => {
                    resolve(getCopyrightResponse);
                },
                (e) => {
                    console.error('getCopyright request failed', e);
                    reject(e);
                },
            );
        });
    };

    // region Smart Footer HTML
    /**
     * Fetches data and builds Smart Footer HTML.
     * @param host
     * @param countryCode
     * @param reg
     * @param iconsSizeMode Optional. See SmartFooterIconsSizeModesEnum for accepted values.
     * @returns {Promise<string>} Smart Footer HTML
     */
    const getSmartFooterHTML = async (
        host,
        countryCode = null,
        reg = null,
        iconsSizeMode = SmartFooterIconsSizeModesEnum.DEFAULT,
    ) => {
        try {
            let smartFooterHtml = '';

            // retrieve smart footer data and templates
            const smartFooterData = await getSmartFooter(host, countryCode, reg);
            const smartFooterSkeletonHtml = await (await fetch(`${getFrameworkUri()}components/smart-footer/smart-footer.html`)).text();

            // parse smart footer item <template> from html string
            const el = document.createElement('div');
            el.innerHTML = smartFooterSkeletonHtml;
            const footerRowTemplate = el.querySelector('#asg-smart-footer-row-template').content.querySelector('[class^="asg-smart-footer-wrap__"]').outerHTML;
            const footerItemTemplate = el.querySelector('#asg-smart-footer-item-template').content.querySelector('.asg-smart-footer__item').outerHTML;

            smartFooterHtml += getSmartFooterPaymentMethodsHtml(
                smartFooterData.data.paymentMethodsList,
                smartFooterData.data.paymentMethods,
                footerItemTemplate,
                footerRowTemplate,
            );

            if (iconsSizeMode === SmartFooterIconsSizeModesEnum.RESIZED_REGULATIONS) {
                const linksPerSizeMode = getRegulationLinksDataPerSizeMode(
                    smartFooterData.data.regulationLinksList,
                    smartFooterData.data.regulationLinks,
                );
                const modesOrder = [
                    SmartFooterIconsSizeModesEnum.DEFAULT,
                    SmartFooterIconsSizeModesEnum.RESIZED_REGULATIONS,
                ];

                modesOrder.forEach(sizeMode => {
                    smartFooterHtml += getSmartFooterRegulationLinksHtml(
                        linksPerSizeMode[sizeMode].list,
                        linksPerSizeMode[sizeMode].data,
                        footerItemTemplate,
                        footerRowTemplate,
                        sizeMode,
                    );
                });
            } else {
                smartFooterHtml += getSmartFooterRegulationLinksHtml(
                    smartFooterData.data.regulationLinksList,
                    smartFooterData.data.regulationLinks,
                    footerItemTemplate,
                    footerRowTemplate,
                );
            }

            return smartFooterSkeletonHtml.replace('[ROWS]', smartFooterHtml);
        } catch (e) {
            Tools.error('AsgFW.getSmartFooterHTML FAILED', e);
            return '';
        }
    };

    /**
     * Builds Payment methods row HTML for Smart Footer.
     * @param paymentMethodsList
     * @param paymentMethods
     * @param itemTemplate
     * @param rowTemplate
     * @returns {string} Payment methods row HTML.
     */
    const getSmartFooterPaymentMethodsHtml = (
        paymentMethodsList,
        paymentMethods,
        itemTemplate,
        rowTemplate,
    ) => {
        const rowType = 'payment';
        let paymentsItemsHtml = '';

        paymentMethodsList.forEach((paymentName) => {
            const { paymentLogo, paymentLink, paymentLinkOpen } = paymentMethods[paymentName];
            let linkTarget = Tools.getLinkTargetAttr(paymentLinkOpen);
            let linkClass = '';

            // disable link in case no href provided from API
            if (!paymentLink) {
                linkTarget = 'onclick="((e)=>{e.preventDefault()})(event)"';
                linkClass = 'asg-smart-footer-item--disabled';
            }

            const imageStyle = paymentLogo.includes('svg')
                ? `-webkit-mask-image: url(${paymentLogo}); mask-image: url(${paymentLogo});`
                : `background-image: url(${paymentLogo})`;

            const imageClass = paymentLogo.includes('svg')
                ? 'asg-smart-footer-item__img-svg'
                : 'asg-smart-footer-item__img-png';

            paymentsItemsHtml += getSmartFooterItemHtml(itemTemplate, {
                itemLink: paymentLink,
                imageStyle,
                hiddenImage: paymentLogo,
                imageClass,
                itemName: paymentName,
                itemClass: linkClass,
                linkTarget,
            });
        });

        return paymentsItemsHtml
            ? rowTemplate.replace('[ROW_TYPE]', rowType)
                .replace('[ROW_CONTENT]', paymentsItemsHtml)
            : '';
    };

    /**
     * Distributes regulation icons data by size modes.
     * @param regulationLinksList
     * @param regulationLinks
     * @returns {{}}
     */
    const getRegulationLinksDataPerSizeMode = (regulationLinksList, regulationLinks) => {
        const defaultModeStateJson = JSON.stringify({
            list: [],
            data: {},
        });
        const dataPerMode = {
            [SmartFooterIconsSizeModesEnum.DEFAULT]: JSON.parse(defaultModeStateJson),
            [SmartFooterIconsSizeModesEnum.RESIZED_REGULATIONS]: JSON.parse(defaultModeStateJson),
        };

        regulationLinksList.forEach((regulationLinkName) => {
            const regulationObject = regulationLinks[regulationLinkName];
            const { iconHeights } = regulationObject;
            const modeKey = iconHeights
                ? SmartFooterIconsSizeModesEnum.RESIZED_REGULATIONS
                : SmartFooterIconsSizeModesEnum.DEFAULT;

            dataPerMode[modeKey].list.push(regulationLinkName);
            dataPerMode[modeKey].data[regulationLinkName] = regulationObject;
        });

        return dataPerMode;
    };

    /**
     * Builds Regulation links row HTML for Smart Footer.
     * @param regulationLinksList
     * @param regulationLinks
     * @param itemTemplate
     * @param rowTemplate
     * @param iconsSizeMode
     * @returns {string}
     */
    const getSmartFooterRegulationLinksHtml = (
        regulationLinksList,
        regulationLinks,
        itemTemplate,
        rowTemplate,
        iconsSizeMode = SmartFooterIconsSizeModesEnum.DEFAULT,
    ) => {
        // As per media rule in smart-footer.html
        const desktopStylesStartWithWidth = 1024;
        const rowType = 'links';
        let regulationItemsHtml = '';

        regulationLinksList.forEach((regulationLinkName) => {
            const { iconLink, iconLinkOpen, iconLogo } = regulationLinks[regulationLinkName];
            const linkTarget = Tools.getLinkTargetAttr(iconLinkOpen);
            let itemStyle = '';
            let hiddenStyle = '';

            let imageStyle = iconLogo.includes('svg')
                ? `-webkit-mask-image: url(${iconLogo}); mask-image: url(${iconLogo});`
                : `background-image: url(${iconLogo});`;

            const imageClass = iconLogo.includes('svg')
                ? 'asg-smart-footer-item__img-svg'
                : 'asg-smart-footer-item__img-png';

            if (iconsSizeMode === SmartFooterIconsSizeModesEnum.RESIZED_REGULATIONS) {
                const { iconHeights } = regulationLinks[regulationLinkName];
                const desktopHeight = iconHeights.desktop;
                const mobileHeight = iconHeights.mobile;
                const iconHeight = window.innerWidth >= desktopStylesStartWithWidth
                    ? desktopHeight
                    : mobileHeight;
                // Force resizing.
                itemStyle = `max-height: ${iconHeight};`;
                imageStyle += `max-height: ${iconHeight};`;
                hiddenStyle = `height: ${iconHeight};`;

                // Force PNG height.
                if (!iconLogo.includes('svg')) {
                    imageStyle += `height: ${iconHeight};`;
                }
            }

            regulationItemsHtml += getSmartFooterItemHtml(itemTemplate, {
                itemLink: iconLink,
                imageStyle,
                hiddenImage: iconLogo,
                hiddenStyle,
                imageClass,
                itemName: regulationLinkName,
                itemStyle,
                linkTarget,
            });
        });

        return regulationItemsHtml
            ? rowTemplate.replace('[ROW_TYPE]', rowType)
                .replace('[ROW_CONTENT]', regulationItemsHtml)
            : '';
    };

    /**
     * Centrally builds the item's HTML.
     *
     * Allows omit some optional placeholders and change/add placeholders in one place.
     * @param itemTemplate
     * @param replaceData
     * @returns {string}
     */
    const getSmartFooterItemHtml = (itemTemplate, replaceData) => {
        // Mandatory
        const {
            itemLink, // [ITEM_LINK]
            imageStyle, // [ITEM_IMG]
            hiddenImage, // [HIDDEN_IMG]
            imageClass, // [IMG_CLASS]
            itemName, // [ITEM_NAME]
            linkTarget, // [ITEM_LINK_TARGET] and related attribute
        } = replaceData;
        // Optional
        let {
            itemStyle = '', // [ITEM_STYLE], related attribute and space before attribute
            itemClass = '', // [ITEM_CLASS] and space before
            hiddenStyle = '', // [HIDDEN_STYLE], related attribute and space before attribute
        } = replaceData;

        itemStyle = Tools.wrapWithHtmlAttribute(itemStyle, 'style');
        hiddenStyle = Tools.wrapWithHtmlAttribute(hiddenStyle, 'style');

        itemStyle = Tools.prependSpace(itemStyle);
        itemClass = Tools.prependSpace(itemClass);
        hiddenStyle = Tools.prependSpace(hiddenStyle);

        return itemTemplate
            .replace('[ITEM_LINK]', itemLink)
            .replace('[ITEM_IMG]', imageStyle)
            .replace('[HIDDEN_IMG]', hiddenImage)
            .replace('[IMG_CLASS]', imageClass)
            .replace('[ITEM_NAME]', itemName)
            .replace('target="[ITEM_LINK_TARGET]"', linkTarget)
            // Replace value[, attribute] and space before to omit if not used.
            .replace(' style="[ITEM_STYLE]"', itemStyle)
            .replace(' [ITEM_CLASS]', itemClass)
            .replace(' style="[HIDDEN_STYLE]"', hiddenStyle);
    };
    // endregion

    /**
     * Calls GET payment-methods Solar API
     * @param countryCode
     * @param reg
     * @return {Promise<unknown>}
     */
    const getPaymentMethods = function (countryCode = null, reg = null) {
        return new Promise((resolve, reject) => {
            const requestParams = {};

            if (countryCode) {
                requestParams.country = countryCode;
            }

            if (reg) {
                requestParams.reg = reg;
            }

            SolarAPI.get(
                '/api/v1/brands/{casinoId}/payment-methods',
                requestParams,
                (getPaymentsResponse) => {
                    resolve(getPaymentsResponse);
                },
                (e) => {
                    console.error('getPaymentMethods request failed', e);
                    reject(e);
                },
            );
        });
    };

    /**
     * Detects if player is Logged in.
     * Calculate the current time measure from the last login.
     * Return object with the current state of time.
     * @returns object
     */
    const sessionTimeView = function () {
        const playerSession = getSessionDetails();
        let timeView = {
            seconds: null,
            minutes: null,
            hours: null,
            days: null,
        };

        if (playerSession) {
            timeView = Tools.getTimeMeasure(playerSession.LoginTimeStamp, new Date());
        }
        return timeView;
    };

    const setHostData = (data, dataId = 1) => {
        // dataId = 1 is default ID on platform side

        if (!isLoggedIn()) {
            throw new Error('API available for logged in players only');
        }

        return new Promise((resolve) => {
            ng_fw.setHostData(data, (result) => {
                resolve(result);
            }, dataId);
        });
    };

    const getHostData = (dataId = 1) => {
        // dataId = 1 is default ID on platform side

        if (!isLoggedIn()) {
            throw new Error('API available for logged in players only');
        }

        return new Promise((resolve) => {
            ng_fw.getHostData((result) => {
                resolve(result);
            }, dataId);
        });
    };

    /**
     * Initiate status-bar functional.
     * https://aspireglobal.atlassian.net/wiki/spaces/ASG/pages/956334301/initStatusBar
     * @param page string - name of current page
     * @returns object
     */
    const initStatusBar = async (page) => getStatusBarConfiguration(page).then(res => res);

    /**
     * Process all status-bar data.
     * receive data from cache or data from API
     * @param page string - name of current page
     * @returns object
     */
    const getStatusBarConfiguration = async (page) => {
        const date = new Date();

        const sso = AsgFW.isLoggedIn() ? 1 : 0;

        const requestParams = {
            sso,
            regulation: getRegulation(),
            country: getCurrentCountry(),
        };

        const cacheData = getStatusBarCache(requestParams);
        let rawStatusBarData = cacheData;

        if (!cacheData) {
            rawStatusBarData = await getStatusBar(requestParams);
            const storageItemKey = getStatusBarCacheKey();
            localStorage.setItem(
                storageItemKey,
                JSON.stringify(
                    {
                        params: requestParams,
                        statusBarData: rawStatusBarData,
                        expiry: date.getTime() + statusBarCacheTtl,
                    },
                ),
            );
        }
        const dataToProcess = rawStatusBarData.data.statusBarData;

        return calculateStatusBarData(
            page,
            dataToProcess,
            !!sso,
        );
    };

    /**
     * Calculate all status-bar data.
     * Returning a status bar calculated object with finalize data.
     * @param page String - name of current page.
     * @param data Object - the object data that received from cache or API.
     * @param loggedIn Boolean - if user is logged in.
     * @returns object
     */
    const calculateStatusBarData = (page, data, loggedIn) => {
        let preparedData = data;

        /*
         * Default status bar data
         */
        let statusBarData = {
            showStatusBar: false,
            showServerTime: false,
            showLocalTime: false,
            showSessionTime: false,
            showFirstName: false,
            showLoyaltyLevel: false,
            showCustomText: '',
            showBalanceView: false,
            showLogoUrl: '',
            showLogoLink: '',
            showBalance: 'Balance',
            displayData: {},
        };

        /*
        * Prepare default Display data.
        * We need it for the Balance display in the subheader
        * even if we don't have the status bar itself.
        */
        const displayData = {};
        if (loggedIn) {
            displayData.sessionTime = sessionTimeView();
            displayData.playerFirstName = getPlayerName();
            displayData.loyaltyLevel = getLoyaltyPoints().CurrentLevelNumber;
            displayData.balanceView = getDisplayBalance()[`Display${statusBarData.showBalance}`];

            statusBarData = {
                ...statusBarData,
                displayData,
            };
        }

        /*
         * Return default data if API response is empty.
         */
        if (!data) {
            return statusBarData;
        }

        /*
         * Fill status bar data with API response.
         */
        try {
            /*
             * Apply overrides
             */
            const { verticalOverrideSport } = preparedData;

            const overridePages = {
                sportPage: verticalOverrideSport,
            };

            if (overridePages[page] && overridePages[page][0]) {
                preparedData = {
                    ...preparedData,
                    ...overridePages[page][0],
                };
            }

            /*
             * Fill the data
             */
            const {
                showStatusBar,
                showServerTime = false,
                showLocalTime,
                showSessionTime,
                showFirstName,
                showLoyaltyLevel,
                showCustomText,
                showBalanceView,
                showLogoUrl,
                showLogoLink,
                showBalance,
                serverTimeZone,
                showTimeZoneAbbreviation,
            } = preparedData;

            // Display status-bar conditions on the specific pages
            if (!validateStatusBarPages(showStatusBar, page)) {
                return statusBarData;
            }

            if (showLocalTime) {
                const date = new Date();
                displayData.localTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            }

            statusBarData = {
                ...statusBarData,
                showLocalTime,
                showLogoUrl,
                showLogoLink,
                displayData,
                showServerTime,
                serverTimeZone,
                showTimeZoneAbbreviation,
                loggedIn,
            };

            /*
            * Prepare post-login data.
            */
            if (loggedIn) {
                // Re-assign Balance, as it might be different because of overrides.
                if (showBalance) {
                    displayData.balanceView = getDisplayBalance()[`Display${showBalance}`];
                }

                statusBarData = {
                    ...statusBarData,
                    showSessionTime,
                    showFirstName,
                    showLoyaltyLevel,
                    showCustomText,
                    showBalanceView,
                    displayData,
                };
            }

            // Final properties validation for the status-bar display
            statusBarData.showStatusBar = checkStatusBarParams(statusBarData);
        } catch (e) {
            console.error('status bar calculator failed', e);
        }

        return statusBarData;
    };

    /**
     * check all status bar values and set display status bar
     * @param statusBarData
     * @returns {boolean}
     */
    const checkStatusBarParams = (statusBarData) => statusBarData.showServerTime
            || statusBarData.showLocalTime
            || statusBarData.showSessionTime
            || statusBarData.showFirstName
            || statusBarData.showLoyaltyLevel
            || statusBarData.showCustomText
            || statusBarData.showBalanceView
            || statusBarData.showLogoUrl?.length > 0;

    /**
     * Calculate status-bar display page data.
     * @param showStatusBar String - data from raw status bar Object.
     * @param page String - Name of current page.
     * @returns Boolean
     */
    const validateStatusBarPages = (showStatusBar, page) => {
        const lobbyOptions = ['lobbypage', 'sportpage'];
        const fixedShowStatusBar = showStatusBar.toLowerCase();
        const fixedPage = page ? page.toLowerCase() : page;
        switch (true) {
        case fixedShowStatusBar === 'off':
        case fixedShowStatusBar === 'gamesonly' && fixedPage !== 'gamepage':
        case fixedShowStatusBar === 'lobbyonly' && !lobbyOptions.includes(fixedPage):
            return false;
        default:
            return true;
        }
    };

    /**
     * Calculate status-bar display page data.
     * @param storageValues Object - the request Params that contains r&c values.
     * @returns Object or null
     */
    const getStatusBarCache = (storageValues) => {
        const date = new Date();
        const storageItemKey = getStatusBarCacheKey();
        const storageData = localStorage.getItem(storageItemKey);
        if (storageData) {
            const parsedData = JSON.parse(storageData);
            const { params, expiry, statusBarData } = parsedData;

            if (Tools.compareShallowObjects(params, storageValues) && date.getTime() < expiry) {
                return statusBarData;
            }
        }
        return null;
    };

    /**
     * Calls GET status-bar Solar API
     * https://aspireglobal.atlassian.net/wiki/spaces/ASG/pages/956399836/status-bar
     * @param requestParams Object - the request Params.
     * @returns Promise
     */
    const getStatusBar = (requestParams) => new Promise((resolve, reject) => {
        SolarAPI.get(
            `/api/v2/brands/${getBrandID()}/status-bar`,
            requestParams,
            (getStatusBarResponse) => {
                resolve(getStatusBarResponse);
            },
            (e) => {
                console.error('getStatusBar request failed', e);
                reject(e);
            },
        );
    });

    /**
     * Returning status bar localstorage key.
     * @returns String
     */
    const getStatusBarCacheKey = () => (isLoggedIn() ? 'status_bar_li' : 'status_bar_lo');

    /**
     * Returns the current PAM platform value.
     */
    const getPamPlatform = () => pamPlatform;

    /**
     * Returns platform
     * @deprecated It was not documented, but public. TODO: Remove in a few versions.
     * @see getPamPlatform()
     */
    const getPlatform = () => {
        Tools.error('The method is deprecated and will be removed soon. Use AsgFW.getPamPlatform() instead.');
        return getPamPlatform();
    };

    /**
     * Retrieves the platform identifier based on the current URL query parameters or defaults.
     *
     * This function checks the URL's query parameters for a "platformid" key. If the key exists
     * and its value matches one of the valid platform IDs, and returns it.
     * If the "platformid" key is absent or invalid, the function determines the platform ID based
     * on whether the environment is a mobile platform or a web platform.
     *
     * @function
     * @returns {number} The determined platform ID.
     */
    const getPlatformId = () => {
        const raw = new URLSearchParams(window.location.search);
        // remap every query key to lowercase
        const lcParams = new URLSearchParams(
            Array.from(raw.entries()).map(([key, value]) => [key.toLowerCase(), value]),
        );
        // Detecting if there is “platformid” present in thw query
        const queryPlatformId = parseInt(lcParams.get('platformid') || '', 10);
        const validPlatformIds = Object.values(PlatformIdsEnum);
        // Returning the platformId detected from the query or default value
        if (!isNaN(queryPlatformId) && validPlatformIds.includes(queryPlatformId)) {
            return queryPlatformId;
        }

        return isMobilePamPlatform()
            ? PlatformIdsEnum.MOBILE_WEB
            : PlatformIdsEnum.WEB;
    };

    /**
     * @return {number[]}
     */
    const getBannerScenes = () => ([1, 2, 3, 4, 5, 6]);

    /**
     * @return {{Game: number, Widget: number, SportLeague: number, Link: number}}
     */
    const getBannerActionTypes = () => ({
        Widget: 1,
        Link: 2,
        Game: 3,
        SportLeague: 4,
    });

    /**
     * @return {
     * {Sport: number,
     * Casino: number,
     * LiveCasino: number,
     * Jackpots: number,
     * Bingo: number}
     * }
     */
    const getBannersCarouselTypes = () => ({
        Casino: 1,
        LiveCasino: 2,
        Sport: 3,
        Jackpots: 4,
        Bingo: 5,
    });

    /**
     * @return {
     * {Deposit: string, TermsInfopage: string, Registration: string, Chat: string, Login: string}
     * }
     */
    const getBannerWidgetActionIDs = () => ({
        Registration: 'Registration',
        Deposit: 'Deposit',
        Login: 'Login',
        Chat: 'Chat',
        InfoPageTerms: 'InfoPageTerms',
    });

    /**
     * @param linkType
     * @param gameId
     * @param targetUrl
     * @return {[null,null]|[number,undefined]|[number,string]}
     */
    const getSegmentedBannerLinkType = (linkType, gameId, targetUrl) => {
        switch (linkType) {
        case 'G':
            return [getBannerActionTypes().Game, String(gameId)];
        case 'E':
            return [getBannerActionTypes().Link, targetUrl];
        case 'M':
            return [getBannerActionTypes().Widget, getBannerWidgetActionIDs().Registration];
        case 'C':
            return [getBannerActionTypes().Widget, getBannerWidgetActionIDs().Deposit];
        default:
            return [null, null];
        }
    };

    /**
     * @param banners
     * @param isPnP
     * @param currency
     * @return {Object[]}
     */
    const mapUnsegmentedBanners = (banners, isPnP, currency) => {
        const [textTnC, linkTnc] = getRegulationTextAndLink();
        return banners.map(b => {
            if ((!b.actions || Object.keys(b.actions).length === 0)
                || (!b.content || Object.keys(b.content).length === 0)
            ) {
                throw new Error('Error Unsegmented banners. Wrong structure');
            }
            return mapBanner({ banner_group: 'unsegmented', PnP: isPnP }, {
                // If no image action: on prelogin - registration, on postlogin - deposit.
                banner: {
                    type: b.actions.banner.type
                        ? b.actions.banner.type
                        : getBannerActionTypes().Widget,
                    // eslint-disable-next-line no-nested-ternary
                    ActionID: b.actions.banner.type ? b.actions.banner.ActionID : (isLoggedIn()
                        ? getBannerWidgetActionIDs().Deposit
                        : getBannerWidgetActionIDs().Registration),
                },
                TnC: {
                    type: b.actions.TnC.type ? b.actions.TnC.type : getBannerActionTypes().Link,
                    ActionID: b.actions.TnC.type ? b.actions.TnC.ActionID : linkTnc,
                },
            }, {
                title: Tools.replaceEmpty(brandNameReplace(currencyReplace(b.content.title, currency)), ''),
                subtitle: Tools.replaceEmpty(brandNameReplace(currencyReplace(b.content.subtitle, currency)), ''),
                CTAtext: Tools.replaceEmpty(brandNameReplace(currencyReplace(b.content.CTAtext, currency)), ''),
                TnC: b.content.TnC
                    ? Tools.replaceEmpty(brandNameReplace(currencyReplace(b.content.TnC, currency)), '')
                    : textTnC,
                image: b.Source || b.content.image,
            });
        });
    };

    /**
     * @param banners
     * @return {Object[]}
     */
    const mapSegmentedBanners = (banners) => {
        const [textTnC, linkTnc] = getRegulationTextAndLink();
        return banners.map(b => {
            const [bannerType, bannerActionId] = getSegmentedBannerLinkType(
                b.LinkType,
                b.GameID,
                b.TargetURL,
            );

            return mapBanner({ banner_group: 'segmented', PnP: false }, {
                banner: {
                    type: Tools.replaceEmpty(bannerType, 0),
                    ActionID: Tools.replaceEmpty(bannerActionId, ''),
                },
                TnC: {
                    type: getBannerActionTypes().Link,
                    ActionID: linkTnc,
                },
            }, {
                image: b.Source,
                TnC: textTnC,
            });
        });
    };

    /**
     * @param banners
     * @param isPnP
     * @param currency
     * @return {Object[]}
     */
    const mapASGBanners = (banners, isPnP, currency) => banners.map(b => mapBanner({ banner_group: 'personalized', PnP: isPnP }, {
        banner: {
            type: Tools.replaceEmpty(b.actions.banner.type, 0),
            ActionID: Tools.replaceEmpty(b.actions.banner.actionID, ''),
        },
        CTA: {
            type: Tools.replaceEmpty(b.actions.cta.type, 0),
            ActionID: Tools.replaceEmpty(b.actions.cta.actionID, ''),
        },
        TnC: {
            type: Tools.replaceEmpty(b.actions.terms_and_condition.type, 0),
            ActionID: Tools.replaceEmpty(b.actions.terms_and_condition.actionID, ''),
        },
    }, {
        image: b.content.image,
        title: Tools.replaceEmpty(brandNameReplace(currencyReplace(b.content.title, currency)), ''),
        subtitle: Tools.replaceEmpty(brandNameReplace(currencyReplace(b.content.subtitle, currency)), ''),
        CTAtext: Tools.replaceEmpty(brandNameReplace(currencyReplace(b.content.cta_text, currency)), ''),
        TnC: Tools.replaceEmpty(brandNameReplace(currencyReplace(b.content.terms_and_condition, currency)), ''),
    }));

    /**
     * Aspire Engage personalized banners
     */
    const getASGBanners = () => aspireEngageBanners || getASGBannersCached();

    /**
     * @returns {null|*}
     */
    const getASGBannersCached = () => {
        if (isLoggedIn()) {
            Tools.log('Aspire Engage banners get from cache', { userID: getEncryptedUserID() });
            return LocalstorageTTLService.get(getASGBannersCacheKey());
        }
        return null;
    };

    /**
     * @returns {string|null}
     */
    const getASGBannersCacheKey = () => (
        isLoggedIn() ? `${asgBannersCacheKey}_${getEncryptedUserID()}` : null
    );

    /**
     * @param carouselTypeParam
     * @param unsegmentedBannersParam
     * @param bannersSceneParam
     * @param isPnPparam
     * @param currency
     * @return {[Object]|null}
     */
    const getAspireEngageBanners = (
        carouselTypeParam,
        unsegmentedBannersParam,
        bannersSceneParam,
        isPnPparam,
        currency,
    ) => {
        let mappedUnsegmentedBanners;
        let mappedSegmentedBanners;
        let mappedEngageBanners;
        let banners = [];
        try {
            if (carouselTypeParam !== undefined && carouselTypeParam !== null
                && (!Number.isInteger(carouselTypeParam)
                    || !Object.values(getBannersCarouselTypes()).includes(carouselTypeParam))
            ) {
                throw new TypeError('Invalid parameter carouselType');
            }
            const carouselType = carouselTypeParam || getBannersCarouselTypes().Casino;

            if (unsegmentedBannersParam !== undefined && unsegmentedBannersParam !== null
                && !Array.isArray(unsegmentedBannersParam)
            ) {
                throw new TypeError('Invalid parameter unsegmentedBanners');
            }
            const unsegmentedBanners = unsegmentedBannersParam || [];

            if (bannersSceneParam !== undefined && bannersSceneParam !== null
                && (!Number.isInteger(bannersSceneParam)
                    || !getBannerScenes().includes(bannersSceneParam))
            ) {
                throw new TypeError('Invalid parameter bannersScene');
            }
            const bannersScene = bannersSceneParam || 1;

            if (isPnPparam !== undefined && isPnPparam !== null
                && !(typeof isPnPparam === 'boolean' || isPnPparam instanceof Boolean)
            ) {
                throw new TypeError('Invalid parameter isPnP');
            }
            const isPnP = Boolean(isPnPparam);

            if (currency !== undefined && currency !== null
                && !(typeof currency === 'string' || currency instanceof String)
            ) {
                throw new TypeError('Invalid parameter currency');
            }

            if (unsegmentedBanners.length) {
                Tools.log('Unsegmented banners are ready');
            }
            let error = false;
            try {
                mappedUnsegmentedBanners = mapUnsegmentedBanners(
                    unsegmentedBanners, isPnP, currency,
                );
            } catch (eUnsegmentedBanners) {
                Tools.log('Error getting Unsegmented banners', eUnsegmentedBanners);
                error = true;
                mappedUnsegmentedBanners = [];
            }
            try {
                mappedSegmentedBanners = mapSegmentedBanners(getSegmentedBannersWeb() || []);
            } catch (eSegmentedBanners) {
                Tools.log('Errors getting Segmented (AspireCore) banners', eSegmentedBanners);
                error = true;
                mappedSegmentedBanners = [];
            }
            try {
                const filteredEngageBanners = (getASGBanners() || []).filter(
                    b => b.carousel_type === carouselType,
                );
                mappedEngageBanners = mapASGBanners(filteredEngageBanners, isPnP, currency);
            } catch (eASGBanners) {
                Tools.log('Error getting Aspire Engage banners', eASGBanners);
                error = true;
                mappedEngageBanners = [];
            }

            [
                mappedUnsegmentedBanners,
                mappedSegmentedBanners,
                mappedEngageBanners,
            ] = retriveBannersByScene(
                bannersScene,
                mappedUnsegmentedBanners,
                mappedSegmentedBanners,
                mappedEngageBanners,
            );

            banners = [
                ...mappedUnsegmentedBanners,
                ...mappedSegmentedBanners,
                ...mappedEngageBanners,
            ];

            if (!error) {
                Tools.log('Banners are ready', banners);
            }

            if (banners.length === 0) {
                Tools.log('No banners available');
                banners = null;
            }
        } catch (e) {
            if (e instanceof TypeError) {
                Tools.log(e.message);
            }
            Tools.log('Error getting banners', e);
        }
        return banners;
    };

    /**
     * @param bannersScene
     * @param mappedUnsegmentedBanners
     * @param mappedSegmentedBanners
     * @param mappedEngageBanners
     * @return {[Object[],Object[],Object[]]}
     */
    const retriveBannersByScene = (
        bannersScene, mappedUnsegmentedBanners, mappedSegmentedBanners, mappedEngageBanners,
    ) => {
        let unsegmentedBanners = mappedUnsegmentedBanners;
        let segmentedBanners = mappedSegmentedBanners;
        let engageBanners = mappedEngageBanners;
        const clearBanners = () => {
            engageBanners = [];
            unsegmentedBanners = [];
            segmentedBanners = [];
        };

        switch (bannersScene) {
        case 1:
            // Step 1: Personalized banner
            if (engageBanners.length) {
                unsegmentedBanners = [];
                segmentedBanners = [];
                // Step 2: If there are no personalized banners,
                // and on postlogin state, segmented banners
            } else if (engageBanners.length === 0
                        && isLoggedIn()
                        && segmentedBanners.length
            ) {
                unsegmentedBanners = [];
                // Step 3: Unsegmented banners
            } else if (unsegmentedBanners.length) {
                segmentedBanners = [];
                // Step 4: Return null status
            } else {
                clearBanners();
            }
            break;
        case 2:
            // Step 1: Personalized banner
            if (engageBanners.length) {
                unsegmentedBanners = [];
                segmentedBanners = [];
                // Step 2: If there no personalized banners,
                // unsegmented banners (for pre and postlogin)
            } else if (unsegmentedBanners.length) {
                segmentedBanners = [];
                // Step 3: On postlogin state, segmented banners
            } else if (isLoggedIn() && segmentedBanners.length) {
                unsegmentedBanners = [];
                // Step 4: Return null status
            } else {
                clearBanners();
            }
            break;
        case 3:
            // Step 1: Personalized banner.
            // After the personalized banners and on postlogin state,
            // segmented banners, after them on all states, unsegmented banners
            if (engageBanners.length) {
                if (isLoggedIn()) {
                    unsegmentedBanners = [];
                }
                // Step 4: Return null status
            } else {
                clearBanners();
            }
            break;
        case 4:
            // Step 1: Personalized banner.
            // After personalized banners, on all states, unsegmented banners
            if (engageBanners.length) {
                segmentedBanners = [];
                // Step 2: On postlogin state, segmented banners
            } else if (isLoggedIn() && segmentedBanners.length) {
                unsegmentedBanners = [];
                // Step 4: Return null status
            } else {
                clearBanners();
            }
            break;
        case 5:
            // Step 1: Personalized banner.
            if (engageBanners.length) {
                unsegmentedBanners = [];
                segmentedBanners = [];
                // Step 4: Return null status
            } else {
                clearBanners();
            }
            break;
        case 6:
            // Step 1: Personalized banner.
            if (engageBanners.length) {
                unsegmentedBanners = [];
                segmentedBanners = [];
                // Step 2: On prelogin state, unsegmented banners
            } else if (!isLoggedIn() && unsegmentedBanners.length) {
                segmentedBanners = [];
                // Step 2: On postlogin state, segmented banners
            } else if (isLoggedIn() && segmentedBanners.length) {
                unsegmentedBanners = [];
                // Step 4: Return null status
            } else {
                clearBanners();
            }
            break;
        default:
            clearBanners();
        }

        return [unsegmentedBanners, segmentedBanners, engageBanners];
    };

    /**
     * @param details
     * @param actions
     * @param content
     * @return {{
     * details: (*&{PnP: number, banner_group: string, Device: (string)}),
     * actions: (*&{
     *    CTA: {ActionID: string, type: number},
     *    TnC: {ActionID: string, type: number},
     *    banner: {ActionID: string, type: number}}),
     * content: (*&{image: string, subtitle: string, TnC: string, title: string, CTAtext: string})}}
     */
    const mapBanner = (
        details,
        actions,
        content,
    ) => ({
        details: {
            Device: isMobilePamPlatform() ? 'mobile' : 'desktop',
            banner_group: '',
            PnP: false,
            ...details,
        },
        actions: {
            banner: {
                type: 0,
                ActionID: '',
            },
            CTA: {
                type: details.PnP ? getBannerActionTypes().Widget : 0,
                ActionID: details.PnP ? getBannerWidgetActionIDs().Deposit : '',
            },
            TnC: {
                type: 0,
                ActionID: '',
            },
            ...actions,
        },
        content: {
            image: '',
            title: '',
            subtitle: '',
            CTAtext: '',
            TnC: '',
            ...content,
        },
    });

    /**
     * @param str
     * @param currency
     * @return {*}
     */
    const currencyReplace = (str, currency) => {
        if (!str || !currency) {
            return str;
        }
        let replacedStr = str;
        if (replacedStr.includes('CurrenciesReplace')) {
            const pattern = /\[CurrenciesReplace\s(.*?)\]/;
            let match;
            // eslint-disable-next-line no-cond-assign
            while ((match = pattern.exec(replacedStr)) !== null) {
                const currenciesEntries = match[1].split(' ').map(el => el.split('=')
                    .map(q => q.replace(/^['"]/, '').replace(/['"]$/, '')));
                const currenciesObj = Object.fromEntries(currenciesEntries);
                if (currenciesObj[currency]) {
                    replacedStr = replacedStr.replace(pattern, () => currenciesObj[currency]);
                }
            }
        }
        return replacedStr;
    };

    /**
     * @param str
     * @return {*}
     */
    const brandNameReplace = (str) => {
        if (!str) {
            return str;
        }
        const needle = '[brandName]';
        let replacedStr = str;
        if (str.includes(needle)) {
            replacedStr = str.replace(needle, getBrandName());
        }
        return replacedStr;
    };

    const getBrandName = () => {
        const brandDomain = getBrandDomain();
        let brandName = '';

        tlds.some(tld => {
            if (!brandDomain.endsWith(tld)) {
                return false;
            }

            const tldIndex = brandDomain.lastIndexOf(tld);
            const domainWoTld = brandDomain.slice(0, tldIndex);
            brandName = domainWoTld.split('.').pop();
            return true;
        });

        // Fallback
        if (!brandName) {
            [brandName] = brandDomain.split('.').slice(-2, -1);
        }

        return Tools.capitalize(brandName);
    };

    /**
     * @return {[string,string]}
     */
    const getRegulationTextAndLink = () => {
        let theText;
        let theLink;

        if (isLoggedIn()) {
            theText = Dictionary.translate('RegulationTermsPostLogin');
            theLink = '/info/bonus-policy/';
        } else {
            theText = Dictionary.translate('RegulationTermsPreLogin');
            theLink = '/promotions/welcome-package/';
        }
        return [theText, theLink];
    };

    const isPayNPlayAvailable = () => {
        try {
            return !AsgFW.isLoggedIn() && AsgFW.getCurrentCountry() === 'fi' && AsgFW.getPayNPlayData().isPayNPlayIntegrationEnabled;
        } catch (e) {
            return false;
        }
    };

    const bingo = {
        loadBingo: (gameId) => {
            tryCloseAndLoadGame(GameVerticalCodesEnum.BINGO, gameId);
        },
        setOnLobbyOpened: (callback) => ng_hs.bingo.lobbyOpened(callback),
        setOnRoomOpened: (callback) => ng_hs.bingo.roomOpened(callback),
        setOnSoundStateChange: (callback) => {
            if (ng_hs.bingo.onSoundStateChange) {
                return ng_hs.bingo.onSoundStateChange(callback);
            }
        },
        openHistory: () => ng_fw.bingo.openHistory(),
        openHelp: () => ng_fw.bingo.openHelp(),
        toggleBingoRoomSound: () => ng_fw.bingo.toggleGameSound(),
    };

    /**
     * Set Datadog properties (RBC and userId)
     */
    const updateDatadogSessionDetails = () => {
        if (!AsgFW.getRbcSettings('datadogRumEnabled')) {
            return;
        }

        const userId = getEncryptedUserID();
        Tools.setDatadogProp('user', 'userId', userId);

        const rbc = getRBC();
        const entries = Object.keys(rbc);
        entries.forEach(k => {
            Tools.setDatadogProp('context', k, rbc[k]);
        });
    };

    // PUBLIC
    return {
        init,
        isAsgHosted,
        initAspireEngage,
        getAppEnv,
        getPamEnv,
        getCdnHost,
        getFncHost,
        getSolarHost,
        getGatewayHost,
        getPamAsgWebApiHost,
        getBrandDomain,
        getBrandDomainWithEnvPrefix,
        getBrandName,
        showLogin,
        showRegistration,
        showDeposit,
        showDepositLimit,
        chatRequiresLogin,
        initChat,
        initFive9Chat,
        chatEventsEnum,
        showChat,
        isChatOpen,
        closeChat,
        startMeasureSessionTime,
        showContactUs,
        showMyAccount,
        showChangePassword,
        showSelfExclusion,
        showGamesHistory,
        showTransactionsHistory,
        closeGame,
        showWithdraw,
        showMyRewards,
        showRealityCheck,
        showLoginHistory,
        logout,
        loadGame,
        getDisplayBalance,
        getLoyaltyPoints,
        isLoggedIn,
        isLoggedInByCookie,
        getPlayerName,
        getPlayerID,
        getEncryptedUserID,
        getLoginTimeStamp,
        getLastLoginTimeStamp,
        getServerTimeStamp,
        isRegistered,
        isExclusiveGame,
        setLoadGameStart,
        setLoadGameClosed,
        setGetJackpots,
        showDocumentUpload,
        setOnSessionStatusUpdate,
        keepAlive,
        showCoolOff,
        setGetBannerDetails,
        getCategories,
        getGamesList,
        getSessionDetails,
        setGetWinnersData,
        setOnGamesListUpdated,
        getBrandID,
        getRegulation,
        getPlayerRegulationType,
        getPlayerCountryCode,
        getFrameworkUri,
        getDsEnv,
        isBrandDK,
        isUkCountry,
        isUkRegulation,
        isDEcountry,
        isDEregion,
        isDEregulation,
        getAsgAPIUri,
        isPresentPageGames,
        getNotPresentGamesList,
        getLastAction,
        getAzureAPIUrl,
        getFetchData,
        setDefaultGameVerticalID,
        getRBC,
        getBrandInit,
        getRbcSettings,
        getRegulationByCountry,
        getCountry,
        getCountryName,
        getCurrentCountry,
        getDetectedCountry,
        getDetectedIsoCountry,
        getDetectedRegulation,
        showAsgContactUs,
        getLanguage,
        getRecentGames,
        closeRegistration,
        closeLogin,
        closeMyAccount,
        closeDeposit,
        closeAllWidgets,
        getPayNPlayData,
        callTakeABreak,
        refreshBalance,
        getLiveCasinoBetLimits,
        getLiveCasinoState,
        getGameSlug,
        getCurrencySignByCode,
        getAsgSrvEnvOverride,
        getAsgServerPrefix,
        getGameById,
        isHideLoyaltyPageFlag,
        isHideNetentGames,
        closeAdnLoadGame,
        closeAndLoadGame,
        isPlayerDECountry,
        getPlayerVerificationDetails,
        showVerificationPopUp,
        onVerificationStatusUpdate,
        getSmartFooter,
        getSmartFooterHTML,
        getPaymentMethods,
        ngRegulationToAsg,
        sessionTimeView,
        initStatusBar,
        fwHostDataIDs,
        setHostData,
        getHostData,
        getCopyright,
        getPlatform,
        getPamPlatform,
        getPlatformId,
        getPamUrls,
        getPamUrlInfoPages,
        isActiveAppealingToChildrenFilter,
        getSegmentedBannersWeb,
        getSegmentedBannerMobile,
        getSegmentedBannerSpecial,
        getSegmentedBannerPopups,
        getRegulationTextAndLink,
        bannersReplaceNGtoAzureStorage,
        getBannersCarouselTypes,
        getAspireEngageBanners,
        isPayNPlayAvailable,
        getCurrency,
        CookieNames,
        PamInstanceUrlTypesEnum,
        GameVerticalCodesEnum,
        GameVerticalCodeToIdEnum,
        GameVerticalIdToCodeEnum,
        EnvVars,
        SmartFooterIconsSizeModesEnum,
        bingo,
        getVersion,
        isMobilePamPlatform,
        setCmsGamesList,
        isNeoCmsIntegrationEnabled,
        getSolarBaseParams,
        PlatformIdsEnum,
    };
})();

/*** EXPORTS FROM exports-loader ***/
export {
  AsgFW
};
